<template>
  <v-card max-height="87vh" min-height="87vh" style="overflow: auto">
    <v-toolbar
      color="indigo"
      dense
      style="position: sticky; top: 0px; z-index: 1"
    >
      <v-toolbar-title class="white--text">Distinta Base</v-toolbar-title>
      <v-spacer></v-spacer>

      <!-- Bottone di creazione articolo nuovo da articolo standard. -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="clickGeneraArticoloStandard"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="orange"> mdi-dolly </v-icon>
          </v-btn>
        </template>
        <span>Genera Nuovo Articolo Standard</span>
      </v-tooltip>

      <!-- Bottone di generazione commessa multipla -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="conferma_commessa_multipla = true"
            :disabled="
              items_distinta_base[0]
                ? items_distinta_base[0].id_commessa != undefined
                : true
            "
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"> mdi-expand-all </v-icon>
          </v-btn>
        </template>
        <span>Genera Commessa Multipla</span>
      </v-tooltip>

      <!-- Bottone di copia dell'articolo -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="clickDuplicaArticolo"
            class="mr-5"
            :disabled="items_distinta_base.length === 0"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary">mdi-content-copy</v-icon>
          </v-btn>
        </template>
        <span>Duplica Articolo</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <!-- Bottone per tornare indietro -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="goBack" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-keyboard-backspace </v-icon>
          </v-btn>
        </template>
        <span>Indietro</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text class="mt-2 pa-0">
      <div style="d-flex" v-show="search_bar_visible">
        <!-- Riga dei filtri -->
        <v-row align="center" class="ma-0 px-5 py-0" justify="center">
          <!-- Filtro del cod_articolo-->
          <v-col align="center" cols="2" justify="center">
            <v-text-field
              @keydown="handleKeydown($event, 'getArticoli')"
              label="Cod. Articolo"
              v-model="cod_articolo_sel"
            >
              <template v-slot:append>
                <v-btn
                  @click="cod_articolo_sel = ''"
                  icon
                  v-show="cod_articolo_sel != ''"
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>

          <v-col align="center" cols="1" justify="center">
            <!-- Bottone di ricerca -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="getArticoli" small v-bind="attrs" v-on="on">
                  <v-icon color="primary"> mdi-magnify </v-icon>
                </v-btn>
              </template>
              <span>Cerca Articolo</span>
            </v-tooltip>
          </v-col>

          <!-- Filtro del tipo famiglia -->
          <v-col align="center" cols="2" justify="center">
            <v-autocomplete
              :items="items_tipo_famiglia"
              label="Tipo Famiglia"
              item-text="des"
              item-value="id_tabella"
              v-model="tipo_famiglia_sel"
            >
              <template v-slot:append>
                <v-btn
                  @click="tipo_famiglia_sel = null"
                  icon
                  v-show="tipo_famiglia_sel != null"
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>
              </template>
            </v-autocomplete>
          </v-col>

          <!-- Filtro Numero Ordine (des_aggiuntiva_articolo) -->
          <v-col align="center" cols="2" justify="center">
            <v-text-field
              label="Numero d'Ordine"
              v-model="des_aggiuntiva_articolo_sel"
            >
            </v-text-field>
          </v-col>

          <!-- Autocomplete per l'associazione del capobarca alla commessa -->
          <v-col align="center" cols="2" justify="center">
            <v-autocomplete
              id="autocomplete_capobarca"
              :items="items_capobarca"
              label="Responsabile"
              item-text="nominativo"
              item-value="id_personale"
              v-model="id_capobarca_sel"
            >
              <template v-slot:prepend>
                <v-icon
                  @click.stop="setcapobarca"
                  color="success"
                  v-if="
                    items_distinta_base[0]
                      ? items_distinta_base[0].id_commessa != undefined
                      : false
                  "
                >
                  mdi-floppy
                </v-icon>
              </template>
            </v-autocomplete>
          </v-col>

          <!-- Autocomplete per l'associazione del capobarca alla commessa -->
          <v-col align="center" cols="2" justify="center">
            <v-autocomplete
              :disabled="
                items_distinta_base[0]
                  ? items_distinta_base[0].id_commessa === undefined
                  : true
              "
              id="autocomplete_stato_commessa"
              :items="items_stati_commessa"
              label="Stati Commessa"
              item-text="des"
              item-value="id_tabella"
              v-model="id_stato_sel"
            >
              <template v-slot:prepend>
                <v-icon
                  @click="clickSetStatoCommessa"
                  color="primary"
                  v-if="
                    items_distinta_base[0]
                      ? items_distinta_base[0].id_commessa != undefined
                      : false
                  "
                >
                  mdi-upload-multiple
                </v-icon>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </div>

      <v-divider
        style="mt-4 mb-3 mx-10"
        v-show="search_bar_visible"
      ></v-divider>

      <!-- Inizio della treeview -->
      <v-treeview
        activatable
        shaped
        hoverable
        :open.sync="open"
        :items="items_distinta_base"
        item-key="id_tmp"
        content="6"
      >
        <template v-slot:prepend="{ item }">
          <b class="mr-2">{{ item.indice }}:</b>
          <!-- Bottone dello stato del nodo padre -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-5"
                color="error"
                fab
                small
                v-bind="attrs"
                v-on="on"
                v-show="
                  item.id_commessa != null &&
                  item.id_commessa_padre != null &&
                  fstItmIsSuspOrAbort
                "
              >
                <v-icon color="white">
                  {{
                    fstItemStatus === id_stato_commessa_annullata
                      ? "mdi-close"
                      : "mdi-pause"
                  }}
                </v-icon>
              </v-btn>
              <!--<span>
                {{
                  fstItemStatus === id_stato_commessa_annullata
                    ? "Annullata"
                    : fstItemStatus === id_stato_commessa_sospesa
                    ? "Sospesa"
                    : fstItemStatus === id_stato_commessa_aperta
                    ? "In Corso"
                    : fstItemStatus === id_stato_commessa_chiusa
                    ? "Chiusa"
                    : ""
                }}
              </span>-->
            </template>
          </v-tooltip>

          <!-- Bottone dello stato del nodo attuale -->
          <v-btn
            :color="
              item.id_stato === id_stato_commessa_chiusa
                ? 'success'
                : item.id_stato === id_stato_commessa_aperta ||
                  item.id_stato === id_stato_commessa_creata
                ? 'orange'
                : 'error'
            "
            class="mr-5"
            fab
            small
            v-if="item.id_commessa != undefined"
          >
            <v-icon color="white">
              {{
                item.id_stato === id_stato_commessa_chiusa
                  ? "mdi-check"
                  : item.id_stato === id_stato_commessa_aperta
                  ? "mdi-play-speed"
                  : item.id_stato === id_stato_commessa_creata
                  ? "mdi-shape-square-plus"
                  : item.id_stato === id_stato_commessa_sospesa
                  ? "mdi-pause"
                  : "mdi-close"
              }}
            </v-icon>
          </v-btn>

          <template v-if="item.id_articolo >= -1">
            {{
              !item.id_commessa
                ? `n° ${item.quantita != null ? item.quantita : 1}`
                : ""
            }}
            {{ !item.id_commessa ? `${item.cod_articolo} ― ` : "" }}
            {{
              item.cod_commessa
                ? `${item.des_commessa ? item.des_commessa : ""}`
                : ""
            }}
            {{ !item.id_commessa ? item.des_articolo : "" }}
          </template>

          <div
            class="ml-5"
            style="display: inline-block"
            v-if="item.id_commessa && item.id_commessa_padre === null"
          >
            <v-chip
              class="elevation-2"
              :color="
                item.id_stato === id_stato_commessa_chiusa
                  ? 'success'
                  : item.id_stato === id_stato_commessa_aperta ||
                    item.id_stato === id_stato_commessa_creata
                  ? 'orange'
                  : 'error'
              "
            >
              <span style="color: white">
                {{
                  item.id_stato === id_stato_commessa_chiusa
                    ? "Completata"
                    : item.id_stato === id_stato_commessa_aperta
                    ? "In Corso"
                    : item.id_stato === id_stato_commessa_creata
                    ? "Creata"
                    : item.id_stato === id_stato_commessa_sospesa
                    ? "Sospesa"
                    : "Annullata"
                }}</span
              >
            </v-chip>
          </div>

          <!-- Pulsante dell'aggiunta di componenti alla distinta base -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-5"
                @click="inserisciComponente(item)"
                small
                v-bind="attrs"
                v-on="on"
                v-if="
                  item.id_stato != id_stato_commessa_annullata &&
                  item.id_commessa
                "
              >
                <v-icon color="primary">mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Inserisci Componente</span>
          </v-tooltip>

          <!-- Pulsante dell'aggiunta note -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-5"
                :color="item.note == '' || item.note == null ? '' : 'orange'"
                @click="aggiungiNota(item)"
                small
                v-bind="attrs"
                v-on="on"
                v-if="
                  item.id_stato != id_stato_commessa_annullata &&
                  item.id_commessa
                "
              >
                <v-icon
                  :color="
                    item.note == '' || item.note == null ? 'primary' : 'white'
                  "
                  >mdi-note-text-outline</v-icon
                >
              </v-btn>
            </template>
            <span>Inserisci Note</span>
          </v-tooltip>

          <!-- Dati di calendario e pulsante di modifica date -->
          <span
            class="ml-5"
            v-if="
              item.id_commessa != undefined && item.id_commessa_padre === null
            "
          >
            <span class="mr-5">
              Commessa:
              <b>{{ formatData(item.data_commessa, "strict") }}</b>
            </span>
            <span class="mr-5">
              Consegna:
              <b>{{ formatData(item.data_consegna, "strict") }}</b>
            </span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="openGestisciDate(item)"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary"> mdi-calendar-edit </v-icon>
                </v-btn>
              </template>
              <span>Gestisci Date</span>
            </v-tooltip>
          </span>

          <!-- Pulsante della modifica nome -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-5"
                @click="modificaDescrizioneCommessa(item)"
                small
                v-bind="attrs"
                v-on="on"
                v-if="
                  item.id_stato != id_stato_commessa_annullata &&
                  item.id_commessa
                "
              >
                <v-icon color="primary">mdi-alphabetical</v-icon>
              </v-btn>
            </template>
            <span>Modifica Descrizione</span>
          </v-tooltip>

          <!-- Pulsante di modifica della commessa -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-5"
                @click="apriDettaglioCommessa(item)"
                small
                v-bind="attrs"
                v-on="on"
                v-if="
                  item.id_stato != id_stato_commessa_annullata &&
                  item.id_commessa
                "
              >
                <v-icon color="primary">mdi-file-cog</v-icon>
              </v-btn>
            </template>
            <span>Dettaglio Commessa</span>
          </v-tooltip>

          <!-- Pulsante dell'aggiunta di componenti alla distinta base -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-5"
                @click="openAssociazioneQuestionario(item)"
                small
                v-bind="attrs"
                v-on="on"
                v-if="
                  item.livello != 1 &&
                  item.id_stato != id_stato_commessa_annullata &&
                  item.id_commessa
                "
              >
                <v-icon color="primary">mdi-timeline-question</v-icon>
              </v-btn>
            </template>
            <span>Associa Questionario</span>
          </v-tooltip>

          <!-- Pulsante di modifica della commessa -->
          <span
            class="ml-5"
            v-if="
              item.id_commessa != undefined &&
              item.livello != 1 &&
              item.id_stato === id_stato_commessa_aperta
            "
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="clickModificaCommessa(item)"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary"> mdi-pencil </v-icon>
                </v-btn>
              </template>
              <span>Modifica Ciclo Produzione</span>
            </v-tooltip>
          </span>

          <!-- Bottone del personale associato -->
          <span
            v-if="
              item.id_commessa != undefined &&
              item.livello != 1 &&
              item.id_stato === id_stato_commessa_aperta
            "
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="ml-5"
                  @click="clickPersonale(item)"
                  :disabled="
                    item.id_stato != id_stato_commessa_aperta ||
                    items_distinta_base[0].id_stato != id_stato_commessa_aperta
                  "
                  small
                  tile
                  v-bind="attrs"
                  v-if="item.id_commessa != undefined"
                  v-on="on"
                >
                  <v-icon color="primary"> mdi-account </v-icon>
                </v-btn>
              </template>
              <span>Personale Associato</span>
            </v-tooltip>
          </span>

          <!-- Pulsante dei consuntivi dei pezzi -->
          <span v-if="item.id_commessa != undefined && item.livello != 1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="clickConsuntiviPezzi(item)"
                  class="ml-5"
                  small
                  tile
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary"> mdi-clipboard-text </v-icon>
                </v-btn>
              </template>
              <span>Consuntivi</span>
            </v-tooltip>
          </span>

          <!-- Pulsante dell'esecuzione del questionario -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-5"
                @click="handleClickCheck(item)"
                small
                :color="
                  item.questionario_completato == 1 ||
                  item.id_stato === id_stato_commessa_chiusa
                    ? 'success'
                    : 'orange'
                "
                v-bind="attrs"
                v-on="on"
                v-if="item.id_commessa != undefined && item.livello != 1"
              >
                <v-icon :color="'#FFFFFF'">mdi-file-document-check</v-icon>
              </v-btn>
            </template>
            <span>Esegui Questionario</span>
          </v-tooltip>

          <!-- Pulsante di eliminazione -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-5"
                @click="clickEliminaCommessa(item)"
                small
                v-bind="attrs"
                v-on="on"
                v-if="
                  item.id_stato != id_stato_commessa_annullata &&
                  item.id_commessa &&
                  item.livello != 1
                "
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Elimina</span>
          </v-tooltip>
        </template>

        <template slot="append" slot-scope="{ item }">
          <div
            class="mr-5"
            style="display: inline-block; height: 28px; width: 50px"
          >
            <!-- Pulsante degli allegati -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="clickGestioneAllegati(item)"
                  small
                  v-if="item.allegato != 0"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary"> mdi-paperclip </v-icon>
                </v-btn>
              </template>
              <span>Visiona Allegati</span>
            </v-tooltip>
          </div>

          <!-- Pulsante delle specifiche -->
          <div
            class="mr-5"
            style="display: inline-block; height: 28px; width: 50px"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="clickSpecifiche(item)"
                  :color="
                    item.view_disegno == 1 || item.id_disegno == null
                      ? ''
                      : 'error'
                  "
                  small
                  v-bind="attrs"
                  v-if="item.id_disegno != 0 && item.id_disegno != null"
                  v-on="on"
                >
                  <v-icon
                    :color="
                      item.view_disegno == 1 || item.id_disegno == null
                        ? 'primary'
                        : 'white'
                    "
                  >
                    mdi-script
                  </v-icon>
                </v-btn>
              </template>
              <span>Specifiche Tecniche</span>
            </v-tooltip>
          </div>

          <!-- Pulsante di play dell'avanzamento produzione -->
          <span
            v-if="
              item.id_commessa != undefined &&
              item.id_stato === id_stato_commessa_aperta &&
              (item.id_disegno == null ||
                (item.id_disegno != null && item.view_disegno == 1))
            "
          >
            <span class="mr-10">
              {{
                `${
                  item.id_commessa
                    ? item.des_um == null || item.des_um == ""
                      ? `Q.tà ${item.quantita}`
                      : `${item.des_um} ${item.quantita}`
                    : ""
                }`
              }}</span
            >
            <v-btn
              class="mr-5"
              @click="clickPlay(item)"
              :color="item.stato_avanzamento === 0 ? 'success' : 'success'"
              :disabled="
                item.id_stato != id_stato_commessa_aperta ||
                items_distinta_base[0].id_stato != id_stato_commessa_aperta
              "
              small
              tile
            >
              <v-icon color="white">
                {{
                  item.numero_registrazioni === 0
                    ? "mdi-play"
                    : "mdi-play-pause"
                }}
              </v-icon>
            </v-btn>
          </span>

          <!-- Pulsante di chiusura massiva dei WO -->
          <span
            v-if="
              item.id_commessa != undefined &&
              item.id_stato === id_stato_commessa_aperta &&
              (item.id_disegno === null ||
                (item.id_disegno != null && item.view_disegno === 1))
            "
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-5"
                  @click="clickChiudiWOMulti(item)"
                  :color="item.stato_avanzamento === 0 ? 'success' : 'success'"
                  :disabled="
                    item.id_stato != id_stato_commessa_aperta ||
                    items_distinta_base[0].id_stato != id_stato_commessa_aperta
                  "
                  small
                  tile
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="white"> mdi-checkbox-multiple-marked </v-icon>
                </v-btn>
              </template>
              <span>Chiusura Massiva WO</span>
            </v-tooltip>
          </span>

          <!-- Pulsante delle versioni -->
          <!--<v-btn
            class="mr-5"
            @click="openComparisonByVersions(item)"
            :color="item.revisione_visualizzata == 0 ? 'error' : ''"
            small
            v-if="
              item.id_commessa != undefined &&
              item.id_commessa_padre === null
            "
          >
            <v-icon
              :color="item.revisione_visualizzata == 0 ? 'white' : 'primary'"
            >
              mdi-eye
            </v-icon>
          </v-btn>-->

          <!-- Pulsante di eliminazione componente -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-5"
                @click="clickEliminaComponente(item)"
                small
                v-bind="attrs"
                v-on="on"
                v-if="item.id_commessa === undefined && item.id_componente != 0"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Elimina Componente</span>
          </v-tooltip>
        </template>
      </v-treeview>

      <!-- Dialog di scelta dell'articolo -->
      <v-dialog persistent v-model="dialog_multiscelta">
        <v-card>
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">Articoli</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="chiudiMultiscelta"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="error">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text class="mt-2" style="overflow-y: auto">
            <v-data-table
              fixed-header
              :headers="headers_articoli"
              max-height="70vh"
              :sort-by="'id_articolo'"
              sort-desc
              :items="items_articoli"
            >
              <template v-slot:[`item.modifica`]="{ item }">
                <v-btn @click="clickScegliArticolo(item)" small>
                  <v-icon color="success">mdi-check</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>

          <!-- Overlay del dialog di scelta -->
          <v-overlay :value="overlay_scelta_articolo">
            <v-progress-circular
              indeterminate
              size="64"
              style="z-index: 20"
            ></v-progress-circular>
          </v-overlay>
        </v-card>
      </v-dialog>

      <!-- Dialog dell'aggiunta multilevel -->
      <v-dialog persistent v-model="dialog_aggiungi_multilevel">
        <v-card>
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text"
              >Aggiungi Componente in
              {{
                articolo_sel.des_articolo
                  ? `${articolo_sel.cod_articolo} - ${articolo_sel.des_articolo}`
                  : articolo_sel.des_commessa
              }}</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <!-- Bottone di salvataggio dei componenti -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-5"
                  @click="salvaAggiuntaDistinta"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="success"> mdi-floppy </v-icon>
                </v-btn>
              </template>
              <span>Salva Modifiche</span>
            </v-tooltip>

            <!-- Bottone per richiamare il modulo Articolo -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="openArticolo" small v-bind="attrs" v-on="on">
                  <v-icon color="primary"> mdi-dolly </v-icon>
                </v-btn>
              </template>
              <span>Articolo</span>
            </v-tooltip>

            <v-spacer></v-spacer>

            <!-- Bottone di chiusura -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="chiudiDialogCommessa"
                  small
                  v-bind="attrs"
                  v-on="on"
                  ><v-icon color="error">mdi-close</v-icon></v-btn
                >
              </template>
              <span>Chiudi</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text class="mt-2" style="overflow-y: auto">
            <div style="d-flex" v-show="search_bar_visible">
              <!-- Riga dei filtri -->
              <v-row align="center" class="ma-0 px-5 py-0" justify="center">
                <!-- Filtro del cod_articolo-->
                <v-col align="center" cols="2" justify="center">
                  <v-text-field
                    @keydown="handleKeydown($event, 'getArticoliAggiunta')"
                    label="Cod. Articolo"
                    v-model="cod_articolo_sel_aggiunta"
                  >
                    <template v-slot:append>
                      <v-btn
                        @click="cod_articolo_sel_aggiunta = ''"
                        icon
                        v-show="cod_articolo_sel_aggiunta != ''"
                      >
                        <v-icon color="error"> mdi-close </v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-col>

                <v-col align="center" cols="1" justify="center">
                  <!-- Bottone di ricerca -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="getArticoliAggiunta"
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="primary"> mdi-magnify </v-icon>
                      </v-btn>
                    </template>
                    <span>Cerca Articolo</span>
                  </v-tooltip>
                </v-col>

                <!-- Filtro del tipo articolo -->
                <v-col align="center" cols="3" justify="center">
                  <v-autocomplete
                    :items="items_tipo_articolo"
                    label="Tipo Articolo"
                    item-text="des"
                    item-value="id_tabella"
                    v-model="tipo_articolo_sel_aggiunta"
                  >
                    <template v-slot:append>
                      <v-btn
                        @click="tipo_articolo_sel_aggiunta = null"
                        icon
                        v-show="tipo_articolo_sel_aggiunta != null"
                      >
                        <v-icon color="error"> mdi-close </v-icon>
                      </v-btn>
                    </template>
                  </v-autocomplete></v-col
                >

                <!-- Filtro del tipo famiglia -->
                <v-col align="center" cols="3" justify="center">
                  <v-autocomplete
                    :items="items_tipo_famiglia"
                    label="Tipo Famiglia"
                    item-text="des"
                    item-value="id_tabella"
                    v-model="tipo_famiglia_sel_aggiunta"
                  >
                    <template v-slot:append>
                      <v-btn
                        @click="tipo_famiglia_sel_aggiunta = null"
                        icon
                        v-show="tipo_famiglia_sel_aggiunta != null"
                      >
                        <v-icon color="error"> mdi-close </v-icon>
                      </v-btn>
                    </template>
                  </v-autocomplete></v-col
                >

                <!-- Filtro del tipo fornitura -->
                <v-col align="center" cols="3" justify="center">
                  <v-autocomplete
                    :items="items_tipo_fornitura"
                    label="Tipo Fornitura"
                    item-text="des"
                    item-value="id_tabella"
                    v-model="tipo_fornitura_sel_aggiunta"
                  >
                    <template v-slot:append>
                      <v-btn
                        @click="tipo_fornitura_sel_aggiunta = null"
                        icon
                        v-show="tipo_fornitura_sel_aggiunta != null"
                      >
                        <v-icon color="error"> mdi-close </v-icon>
                      </v-btn>
                    </template>
                  </v-autocomplete></v-col
                >
              </v-row>
            </div>
            <!-- Tabella degli articoli passibili di essere aggiunti -->
            <v-data-table
              fixed-header
              :headers="headers_articoli_aggiunta"
              max-height="70vh"
              :items="items_articoli_aggiunta"
            >
              <template v-slot:[`item.quantita`]="{ item }">
                <v-text-field
                  dense
                  hide-details
                  type="number"
                  style="max-width: 75px"
                  v-model="item.quantita"
                >
                </v-text-field>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Dialog di conferma generazione commessa multipla -->
      <v-dialog v-model="conferma_commessa_multipla" persistent width="500px">
        <v-card>
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text"
              >Conferma Generazione Commessa Multipla</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="chiudiConfermaCommessaMultipla"
                  small
                  v-bind="attrs"
                  v-on="on"
                  ><v-icon color="error">mdi-close</v-icon></v-btn
                >
              </template>
              <span>Chiudi</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text class="mt-5" style="overflow-y: auto">
            <span style="font-size: 18px">
              Inserire la Data di Commessa e la Data di Consegna per confermare
              la generazione della Commessa.
            </span>
            <v-container>
              <v-row align="center" justify="center">
                <v-col cols="6">
                  <v-menu
                    v-model="calendario_data_commessa"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    min-width="289"
                    transition="scale-transition"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        background-color="#ffffff"
                        hide-details
                        label="Data Commessa"
                        v-model="data_commessa_formattata"
                        readonly
                        v-on="on"
                      >
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="data_commessa"
                      @input="calendario_data_commessa = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <v-menu
                    v-model="calendario_data_consegna"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    min-width="289"
                    transition="scale-transition"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        background-color="#ffffff"
                        hide-details
                        label="Data Consegna Prevista"
                        v-model="data_consegna_formattata"
                        readonly
                        v-on="on"
                      >
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="data_consegna"
                      @input="calendario_data_consegna = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
            <v-divider class="mt-4 mb-3"></v-divider>
            <div>
              <v-btn @click="setCommessaMultipla" small>
                <v-icon color="success"> mdi-check </v-icon>
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Dialog di conferma eliminazione articolo dalla distinta base -->
      <v-dialog v-model="conferma_elimina_articolo" persistent width="500">
        <v-card>
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text"
              >Conferma Eliminazione</v-toolbar-title
            >
          </v-toolbar>
          <v-card-text class="mt-5" style="overflow-y: auto">
            <span style="font-size: 18px">
              Confermi l'eliminazione del componente
              {{ articolo_sel.cod_articolo }} dalla distinta base?
            </span>

            <v-divider class="mt-4 mb-3"></v-divider>

            <div>
              <v-btn @click="eliminaComponente" small>
                <v-icon color="success"> mdi-check </v-icon>
              </v-btn>

              <v-btn @click="conferma_elimina_articolo = false" small>
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Dialog di conferma eliminazione commessa -->
      <v-dialog v-model="conferma_elimina_commessa" persistent width="500">
        <v-card>
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">
              Conferma Eliminazione
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text class="mt-5" style="overflow-y: auto">
            <span style="font-size: 18px">
              Confermi l'eliminazione della commessa?
            </span>

            <v-divider class="mt-4 mb-3"></v-divider>

            <div>
              <v-btn class="mr-5" @click="eliminaCommessa" small>
                <v-icon color="success"> mdi-check </v-icon>
              </v-btn>

              <v-btn @click="conferma_elimina_commessa = false" small>
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Dialog del carrello WO -->
      <v-dialog v-model="dialog_avanzamento">
        <Produzione2
          :back_as_landing_page="false"
          class="ma-0 pa-0"
          @click_indietro="handleClickIndietro"
          :cod_commessa="articolo_sel.cod_commessa"
          :commessa="articolo_sel"
          :flag_italproget="true"
          :filtroEM="'1'"
          :headers_carrello="headers_carrello"
          :id_stato_commessa_chiusa="id_stato_commessa_chiusa"
          :multicommessa_visible="false"
          :open_consuntivi_if_empty="true"
          :visible="dialog_avanzamento"
        />
      </v-dialog>

      <!-- Dialog di comparazione versioni documentazione -->
      <v-dialog v-model="dialog_comparazione_versioni">
        <ComparazioneVersioni
          @chiudi_dialog="chiudiComparazioneVersioni"
          class="ma-0 pa-0"
          :id_commessa="articolo_sel.id_commessa"
          ref="ComparazioneVersioni"
        />
      </v-dialog>

      <!-- Dialog di conferma duplicazione articolo -->
      <v-dialog v-model="conferma_duplica_dialog" width="unset">
        <v-card>
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">
              Conferma Duplicazione
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="
                    duplicaArticolo();
                    conferma_duplica_dialog = false;
                  "
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="success">mdi-floppy</v-icon>
                </v-btn>
              </template>
              <span>Duplica</span>
            </v-tooltip>

            <v-spacer></v-spacer>

            <!-- Bottone di annullamento -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="
                    conferma_duplica_dialog = false;
                    cod_articolo_duplicazione = '';
                    des_aggiuntiva_duplicazione = '';
                    des_articolo_duplicazione = '';
                  "
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="error">mdi-keyboard-backspace</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text class="mt-5" style="overflow-y: auto">
            <span style="font-size: 18px">
              Per confermare la duplicazione, inserire i campi di testata per il
              nuovo articolo da creare.
            </span>
            <v-container>
              <v-row align="center" justify="center">
                <v-col class="align-center d-flex justify-end" cols="4">
                  <v-text-field
                    class="mr-5"
                    hide-details
                    label="Cod. Articolo"
                    style="max-width: 200px"
                    v-model="cod_articolo_duplicazione"
                  ></v-text-field>
                </v-col>
                <v-col class="align-center d-flex justify-start" cols="4">
                  <v-text-field
                    class="ml-5"
                    hide-details
                    label="Des. Articolo"
                    style="max-width: 200px"
                    v-model="des_articolo_duplicazione"
                  ></v-text-field>
                </v-col>
                <v-col class="align-center d-flex justify-start" cols="4">
                  <v-text-field
                    class="ml-5"
                    hide-details
                    label="Numero d'Ordine"
                    style="max-width: 200px"
                    v-model="des_aggiuntiva_duplicazione"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Dialog di generazione nuovo articolo -->
      <v-dialog v-model="conferma_nuovo_articolo_dialog" width="unset">
        <v-card>
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">
              Nuovo Articolo Standard
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="
                    generaArticoloStandard();
                    conferma_nuovo_articolo_dialog = false;
                  "
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="success">mdi-floppy</v-icon>
                </v-btn>
              </template>
              <span>Duplica</span>
            </v-tooltip>

            <v-spacer></v-spacer>

            <!-- Bottone di annullamento -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="
                    conferma_nuovo_articolo_dialog = false;
                    cod_articolo_duplicazione = '';
                    des_aggiuntiva_duplicazione = '';
                    des_articolo_duplicazione = '';
                  "
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="error">mdi-keyboard-backspace</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text class="mt-5" style="overflow-y: auto">
            <span style="font-size: 18px">
              Inserire i campi di testata del nuovo articolo.
            </span>
            <v-container>
              <v-row align="center" justify="center">
                <v-col class="align-center d-flex justify-end" cols="4">
                  <v-text-field
                    class="mr-5"
                    hide-details
                    label="Cod. Articolo"
                    style="max-width: 200px"
                    v-model="cod_articolo_duplicazione"
                  ></v-text-field>
                </v-col>
                <v-col class="align-center d-flex justify-start" cols="4">
                  <v-text-field
                    class="ml-5"
                    hide-details
                    label="Des. Articolo"
                    style="max-width: 200px"
                    v-model="des_articolo_duplicazione"
                  ></v-text-field>
                </v-col>
                <v-col class="align-center d-flex justify-start" cols="4">
                  <v-text-field
                    class="ml-5"
                    hide-details
                    label="Descrizione Aggiuntiva"
                    style="max-width: 200px"
                    v-model="des_aggiuntiva_duplicazione"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Dialog per la visualizzazione delle specifiche tecniche -->
      <v-dialog persistent v-model="visualizza_disegno_visible">
        <VisualizzaDisegno
          @click_chiudi="chiudiDisegno"
          :visible="visualizza_disegno_visible"
          :work_order_sel="articolo_sel"
        />
      </v-dialog>

      <!-- Dialog degli allegati -->
      <v-dialog v-model="gestione_allegati_visible">
        <GestioneAllegato
          ref="componenteAllegati"
          @click_chiudi="gestione_allegati_visible = false"
          controller_allegati="Global"
          controller_caratteristiche_tabella="Manutenzione"
          :id_riferimento="articolo_sel.id_articolo"
          tipo_allegato="ARTICOLO"
          @snackbarOpen="snackbarOpen"
          :read_only="true"
        />
      </v-dialog>

      <!-- Dialog di conferma annullamento commessa -->
      <v-dialog v-model="conferma_stato_commessa" persistent width="500px">
        <v-card>
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">
              Conferma Cambio Stato Commessa
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text class="mt-5">
            <span style="color: black; font-size: 20px">
              Confermi di voler cambiare lo stato di questa commessa in
              <b>{{
                id_stato_sel === id_stato_commessa_creata
                  ? "Creata"
                  : id_stato_sel === id_stato_commessa_aperta
                  ? "Aperta"
                  : id_stato_sel === id_stato_commessa_chiusa
                  ? "Chiusa"
                  : id_stato_sel === id_stato_commessa_sospesa
                  ? "Sospesa"
                  : "Annullata"
              }}</b
              >?
            </span>

            <v-divider class="my-5"></v-divider>

            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-btn class="mr-5" @click="conferma_stato_commessa = false">
                    <v-icon color="error" large>mdi-close</v-icon>
                  </v-btn>
                  <v-btn
                    class="mr-5"
                    @click="
                      setStatoCommessa();
                      conferma_stato_commessa = false;
                    "
                  >
                    <v-icon color="success" large> mdi-check </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Dialog di scelta della modifica delle fasi in articolo o commessa -->
      <v-dialog v-model="scegli_mod_edit_ciclo_prod" persistent width="500px">
        <v-card>
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">
              Modifica il Ciclo di Produzione
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="scegli_mod_edit_ciclo_prod = false"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text class="mt-5">
            <span style="color: black; font-size: 20px">
              Da qui è possibile modificare il Ciclo Produzione dell'Articolo o
              della Commessa attuale:
            </span>

            <v-divider class="my-5"></v-divider>

            <v-container>
              <v-row align="center" justify="center">
                <v-col cols="12">
                  <v-btn class="mr-5" @click="editCicloArticolo">
                    <span style="color: rgb(25, 118, 210)">Articolo</span>
                  </v-btn>
                  <v-btn class="mr-5" @click="editCicloCommessa">
                    <span style="color: rgb(25, 118, 210)">Commessa</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Dialog di modifica delle fasi in articolo -->
      <v-dialog v-model="ciclo_fasi_articolo" persistent>
        <v-card>
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">
              Modifica Ciclo Produzione Articolo {{ articolo_sel.des_commessa }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="chiudiCicloFasiArticolo"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text class="mt-5">
            <ArticoloCicloFasiNew
              :data="dettaglio_articolo"
              :key="key_ciclo_articolo"
            />
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Dialog di modifica delle fasi in commessa -->
      <v-dialog v-model="ciclo_fasi_commessa" persistent>
        <v-card>
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">
              Modifica Ciclo Produzione Articolo {{ articolo_sel.des_commessa }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="setCommessa" small>
              <v-icon color="success"> mdi-floppy </v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="chiudiCicloFasiCommessa"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text class="mt-5">
            <CommessaCicloProdNew
              :cicloData="dati_ciclo"
              :idArticolo="articolo_sel.id_articolo"
              :key="key_ciclo_commessa"
              ref="CommessaCicloProdNew"
            />
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Dialog di conferma chiusura massiva WO -->
      <v-dialog v-model="conferma_chiudi_mass_wo" max-width="800px">
        <v-card>
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">
              Chiusura Commessa
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="chiudiWOMulti" small v-bind="attrs" v-on="on">
                  <v-icon color="success"> mdi-floppy </v-icon>
                </v-btn>
              </template>
              <span>Salva</span>
            </v-tooltip>

            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="annullaChiudiWOMass"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text class="mt-5" style="overflow-y: auto">
            <div>
              <span style="color: rgb(0, 0, 0); font-size: 18px">
                Confermi di voler chiudere tutti i Work Orders associati a
                questa commessa?
              </span>
            </div>
            <div class="my-5">
              <span style="color: rgb(0, 0, 0); font-size: 18px">
                <b>{{ articolo_sel.cod_commessa }}</b>
              </span>
            </div>

            <!-- Tabella dei WO che verranno chiusi massivamente -->
            <v-data-table
              :headers="headers_fasi_chiusura"
              :items="items_fasi_chiusura"
            >
              <template v-slot:top>
                <v-toolbar color="indigo" dense>
                  <v-toolbar-title class="white--text">
                    Work Order in Chiusura
                  </v-toolbar-title>
                </v-toolbar>
              </template>

              <!-- Input della data start -->
              <template v-slot:[`item.data_start`]="{ item }">
                <v-menu
                  v-model="item.calendario_data_start"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="289"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      hide-details
                      label="Data Start"
                      :value="formatData(item.data_start, 'full')"
                      readonly
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="item.data_start"
                    @input="item.calendario_data_start = false"
                  ></v-date-picker>
                </v-menu>
              </template>

              <!-- Input dell'ora di start -->
              <template v-slot:[`item.ora_start`]="{ item }">
                <v-menu
                  v-model="item.calendario_ora_start"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="289"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      hide-details
                      label="Ora Start"
                      :value="formatOra(item.ora_start)"
                      readonly
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <v-time-picker
                    v-model="item.ora_start"
                    @input="item.calendario_ora_start = false"
                  ></v-time-picker>
                </v-menu>
              </template>

              <!-- Input della data stop -->
              <template v-slot:[`item.data_stop`]="{ item }">
                <v-menu
                  v-model="item.calendario_data_stop"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="289"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      hide-details
                      label="Data Stop"
                      :value="formatData(item.data_stop, 'full')"
                      readonly
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="item.data_stop"
                    @input="item.calendario_data_stop = false"
                  ></v-date-picker>
                </v-menu>
              </template>

              <!-- Input dell'ora di stop -->
              <template v-slot:[`item.ora_stop`]="{ item }">
                <v-menu
                  v-model="item.calendario_ora_stop"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="289"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      hide-details
                      label="Ora Stop"
                      :value="formatOra(item.ora_stop)"
                      v-model="item.ora_stop"
                      readonly
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <v-time-picker
                    v-model="item.ora_stop"
                    @input="item.calendario_ora_stop = false"
                  ></v-time-picker>
                </v-menu>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>

        <!-- Overlay del dialog di chiusura massiva -->
        <v-overlay :value="overlay_chiusura_massiva">
          <v-progress-circular
            indeterminate
            size="64"
            style="z-index: 20"
          ></v-progress-circular>
        </v-overlay>
      </v-dialog>

      <!-- Dialog Fasi e Personale -->
      <v-dialog v-model="dialog_personale_fasi" width="unset">
        <!-- Loader -->
        <v-overlay :value="overlay" style="z-index: 10">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card>
          <v-toolbar dark color="indigo" dense>
            <v-toolbar-title>Ciclo Commessa Produzione</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="setPersonaleCommessa"
                  v-on="on"
                  light
                  v-bind="attrs"
                  small
                >
                  <v-icon color="success">mdi-floppy</v-icon>
                </v-btn>
              </template>
              <span>Salva</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="closeDialogCicli"
                  v-on="on"
                  light
                  v-bind="attrs"
                  small
                >
                  <v-icon color="error">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>
          </v-toolbar>

          <v-card-text class="pt-3">
            <v-data-table :headers="headers_ciclo" :items="ciclo_lista">
              <template v-slot:[`item.personale_new`]="{ item }">
                <v-select
                  @change="logProva(item)"
                  v-model="item.personale_new"
                  :items="personale_list"
                  :item-text="
                    (item) =>
                      item.cognome != null
                        ? item.cognome + ' ' + item.nome
                        : item.nome
                  "
                  item-value="id_utente"
                  return-object
                  label="Seleziona il nominativo"
                  multiple
                  style="width: 300px"
                ></v-select>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Finestra di dialogo dei consuntivi dei pezzi -->
      <v-dialog v-model="dialog_tabella_pezzi">
        <TabellaPezzi
          @click_chiudi="dialog_tabella_pezzi = false"
          @click_tabella_tempi="
            dialog_tabella_tempi = false;
            clickConsuntiviTempi(articolo_sel);
          "
          :cod_commessa_sel="articolo_sel.cod_commessa"
          :key="key_tabella_pezzi"
          :show_btn_tempi="true"
          style="padding: 0px"
        />
      </v-dialog>

      <!-- Finestra di dialogo dei consuntivi dei pezzi -->
      <v-dialog v-model="dialog_tabella_tempi">
        <TabellaTempi
          @click_chiudi="dialog_tabella_tempi = false"
          @click_tabella_pezzi="
            dialog_tabella_tempi = false;
            clickConsuntiviPezzi(articolo_sel);
          "
          :cod_commessa_sel="articolo_sel.cod_commessa"
          :key="key_tabella_tempi"
          :show_btn_pezzi="true"
          style="padding: 0px"
        />
      </v-dialog>

      <!-- Finestra di dialogo dell'associazione questionari -->
      <v-dialog v-model="dialog_associazioni_questionario" max-width="800px">
        <AssociaQuestionariEM
          @click_chiudi="chiudiAssociazioni"
          :commessa_principale="articolo_sel"
          :items_commesse="items_commesse_questionario"
          :visible="dialog_associazioni_questionario"
        />
      </v-dialog>

      <!-- Dialog dei questionari -->
      <v-dialog class="ma-0 pa-0" v-model="check_dialog_visible">
        <v-card
          class="ma-0 pa-0"
          height="calc(100vh - 100px)"
          style="overflow: hidden"
        >
          <div style="position: relative; height: 100%">
            <WindowFrame
              class="ma-0 pa-0"
              @click_chiudi="closeCheck"
              :component="'check'"
              @fine_sessione_check="handleFineSessione"
              :input_args="input_args"
              :key="key_check"
              ref="windowframe_check"
            />
          </div>
        </v-card>
      </v-dialog>

      <!-- Dialog delle date di commessa / consegna -->
      <v-dialog class="ma-0 pa-0" max-width="500px" v-model="gestione_date">
        <v-card>
          <v-toolbar class="indigo white--text" dense>
            <v-toolbar-title class="white--text">
              Gestione Date di Commessa
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" @click="saveGestisciDate()" small>
                  <v-icon color="success"> mdi-floppy </v-icon>
                </v-btn>
              </template>
              <span>Salva</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" @click="gestione_date = false" small>
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text class="mt-5">
            <v-container fluid>
              <v-row align="center" justify="center">
                <v-col cols="6">
                  <v-menu
                    v-model="calendario_data_commessa"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    min-width="289"
                    transition="scale-transition"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        background-color="#ffffff"
                        dense
                        hide-details
                        label="Data Commessa"
                        outlined
                        readonly
                        style="border-radius: 0px"
                        v-model="data_commessa_formattata"
                        v-on="on"
                      >
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="data_commessa"
                      @input="calendario_data_commessa = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <v-menu
                    v-model="calendario_data_consegna"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    min-width="289"
                    transition="scale-transition"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        dense
                        hide-details
                        label="Data Consegna"
                        outlined
                        readonly
                        style="border-radius: 0px"
                        v-model="data_consegna_formattata"
                        v-on="on"
                      >
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="data_consegna"
                      @input="calendario_data_consegna = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <!-- Overlay di caricamento delle date -->
          <v-overlay :value="overlay_gestione_date">
            <v-progress-circular
              indeterminate
              size="64"
              style="z-index: 20"
            ></v-progress-circular>
          </v-overlay>
        </v-card>
      </v-dialog>

      <!-- Dialog dell'articolo -->
      <v-dialog v-model="articolo_dialog">
        <Articolo
          :back_as_landing_page="false"
          @click_chiudi="closeArticolo"
          :key="key_articolo"
          style="border-radius: 0px; padding: 0px"
        />
      </v-dialog>

      <!-- Finestra di dialogo per chiudere automaticamente le commesse -->
      <v-dialog v-model="dialog_chiusure_automatiche">
        <v-card>
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">
              Chiusura Commesse
            </v-toolbar-title>
            <v-spacer></v-spacer>

            <!-- Bottone di salvataggio -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="salvaChiusureCommesse"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="success">mdi-floppy</v-icon>
                </v-btn>
              </template>
              <span>Salva</span>
            </v-tooltip>

            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="chiudiChiusureAutomatiche"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="error">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text style="overflow-y: auto">
            <v-data-table
              :headers="headers_chiusure_automatiche"
              :items="items_chiusure_automatiche"
            >
              <template v-slot:[`item.selezionato`]="{ item }">
                <v-checkbox
                  :false-value="0"
                  :true-value="1"
                  v-model="item.selezionato"
                >
                </v-checkbox>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Dialog di modifica descrizione commessa -->
      <v-dialog v-model="dialog_modifica_descrizione" width="500">
        <v-card>
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">Descrizione</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="salvaModificaDescrizione"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="success">mdi-floppy</v-icon>
                </v-btn>
              </template>
              <span>Salva</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="dialog_modifica_descrizione = false"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="error">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text style="overflow-y: auto">
            <v-container class="mt-5" fluid>
              <v-row align="center" justify="center">
                <v-col cols="12">
                  <v-text-field
                    dense
                    hide-details
                    v-model="riga_sel.des_commessa"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>

        <!-- Overlay di caricamento del dialog -->
        <v-overlay :value="overlay" style="z-index: 10">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-dialog>

      <!-- Dialog modifica note -->
      <v-dialog v-model="dialog_note_commessa" width="500">
        <v-card>
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">Note</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="salvaNoteCommessa"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="success">mdi-floppy</v-icon>
                </v-btn>
              </template>
              <span>Salva</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="dialog_note_commessa = false"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="error">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text class="mt-5" style="overflow-y: auto">
            <v-container fluid>
              <v-row align="center" justify="center">
                <v-col cols="12">
                  <v-textarea
                    dense
                    hide-details
                    outlined
                    style="border-radius: 0px"
                    v-model="riga_sel.note"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>

        <!-- Overlay di caricamento del dialog -->
        <v-overlay :value="overlay" style="z-index: 10">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-dialog>

      <!-- Dialog Modifica Commessa -->
      <v-dialog v-model="dialog_dettaglio_commessa" width="90vw">
        <div style="max-height: 80vh">
          <CommesaDashBoard
            class="pa-0"
            @click_chiudi_dettaglio="dialog_dettaglio_commessa = false"
            :componente_interno="true"
            :id_commessa="riga_sel.id_commessa"
            @salvataggio_effettuato="getWorkOrders"
            :v-if="dialog_dettaglio_commessa"
          />
        </div>
      </v-dialog>

      <!-- Snackbar -->
      <SnackbarQV ref="SnackbarQV" />

      <!-- Overlay generico -->
      <v-overlay :value="overlay" style="z-index: 20">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card-text>
  </v-card>
</template>
<script>
import _ from "lodash";
import Articolo from "@/views/PRODUCTION/Articolo/Articolo.vue";
import ArticoloCicloFasiNew from "@/views/PRODUCTION/Articolo/CicoloFasi/ArticoloCicloFasiNew.vue";
import AssociaQuestionariEM from "@/components/ELECTRICALMARINE/AssociaQuestionariEM.vue";
import CommessaCicloProdNew from "@/views/PRODUCTION/Commesa/CommessaCicloProdNew.vue";
import CommesaDashBoard from "@/views/PRODUCTION/Commesa/CommesaDashBoard.vue";
import ComparazioneVersioni from "@/views/TOOLS/ComparazioneVersioni.vue";
import GestioneAllegato from "@/components/TOOLS/GestioneAllegato.vue";
import moment from "moment/moment";
import Produzione2 from "@/views/PRODUCTION/ProduzioneOnline/Produzione2.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import TabellaPezzi from "@/components/PRODUCTION/Avanzamento/TabellaPezzi.vue";
import TabellaTempi from "@/components/PRODUCTION/Avanzamento/TabellaTempi.vue";
import VisualizzaDisegno from "@/components/PRODUCTION/ProduzioneOnline/VisualizzaDisegno.vue";
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";

class ArticoloClass {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  reset() {
    const campi = this.setCampi();
    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "barcode", default_val: "" },
      { nome: "chkGenera", default_val: null },
      { nome: "cod_articolo", default_val: "" },
      { nome: "cod_commessa", default_val: "" },
      { nome: "data_commessa", default_val: "" },
      { nome: "data_consegna", default_val: "" },
      { nome: "data_spedizione", default_val: "" },
      { nome: "des_articolo", default_val: "" },
      { nome: "des_commessa", default_val: "" },
      { nome: "id_articolo", default_val: null },
      { nome: "id_articolo_disegno", default_val: null },
      { nome: "id_ciclo_testa", default_val: null },
      { nome: "id_commessa", default_val: null },
      { nome: "id_commessa_padre", default_val: null },
      { nome: "id_commessa_avo", default_val: null },
      { nome: "id_componente", default_val: null },
      { nome: "id_disegno", default_val: null },
      { nome: "id_distinta_base", default_val: null },
      { nome: "id_famiglia", default_val: null },
      { nome: "id_lotto", default_val: null },
      { nome: "id_magazzino", default_val: null },
      { nome: "id_padre", default_val: null },
      { nome: "id_personale", default_val: null },
      { nome: "id_stato", default_val: null },
      { nome: "id_tipo", default_val: null },
      { nome: "id_tipo_fornitura", default_val: null },
      { nome: "id_tmp", default_val: null },
      { nome: "livello", default_val: null },
      { nome: "nominativo", default_val: "" },
      { nome: "note", default_val: "" },
      { nome: "nr_fasi", default_val: 0 },
      { nome: "numero_commessa", default_val: null },
      { nome: "qtaTotale", default_val: 1 },
      { nome: "quantita", default_val: 1 },
      { nome: "riferimento", default_val: null },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}

export default {
  name: "DistintaMultilevel",
  components: {
    Articolo,
    ArticoloCicloFasiNew,
    AssociaQuestionariEM,
    CommessaCicloProdNew,
    CommesaDashBoard,
    ComparazioneVersioni,
    GestioneAllegato,
    Produzione2,
    SnackbarQV,
    TabellaPezzi,
    TabellaTempi,
    VisualizzaDisegno,
    WindowFrame,
  },
  props: {
    back_as_landing_page: {
      type: Boolean,
      default: true,
    },
    id_articolo: {
      type: Number,
      default: null,
    },
    search_bar_visible: {
      type: Boolean,
      default: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      articolo_sel: new ArticoloClass(),
      cod_articolo_sel: "",
      cod_articolo_sel_aggiunta: "",
      cod_articolo_duplicazione: "",
      cod_profilo: null,
      commessa: new Object(),
      conferma_duplica_dialog: false,
      conferma_nuovo_articolo_dialog: false,
      data_commessa: "",
      data_consegna: "",
      dati_ciclo: null,
      des_aggiuntiva_articolo_sel: "",
      des_articolo_duplicazione: "",
      des_aggiuntiva_duplicazione: "",
      dettaglio_articolo: null,
      id_art_inserimento_componente: null,
      id_articolo_sel: null,
      id_modulo_nuovi_componenti: null,
      id_capobarca_sel: null,
      id_comm_inserimento_componente: null,
      id_stato_commessa_annullata: null,
      id_stato_commessa_aperta: null,
      id_stato_commessa_chiusa: null,
      id_stato_commessa_creata: null,
      id_stato_commessa_sospesa: null,
      id_stato_sel: null,
      input_args: new Object(),
      key_articolo: 0,
      key_check: 0,
      key_ciclo_articolo: 0,
      key_ciclo_commessa: 0,
      check_dialog_visible: false,
      key_tabella_pezzi: 0,
      key_tabella_tempi: 0,
      prefisso_utente: null,
      quest_app_exec_ok: false,
      riga_sel: new Object(),
      tipo_articolo_sel: null,
      tipo_articolo_sel_aggiunta: null,
      tipo_famiglia_sel: null,
      tipo_famiglia_sel_aggiunta: null,
      tipo_fornitura_sel: null,
      tipo_fornitura_sel_aggiunta: null,

      // Modal
      articolo_dialog: false,
      calendario_data_commessa: false,
      calendario_data_consegna: false,
      caricamento_dati: false,
      ciclo_fasi_articolo: false,
      ciclo_fasi_commessa: false,
      conferma_chiudi_mass_wo: false,
      conferma_commessa_multipla: false,
      conferma_elimina_articolo: false,
      conferma_elimina_commessa: false,
      conferma_stato_commessa: false,
      dialog_aggiungi_multilevel: false,
      dialog_associazioni_questionario: false,
      dialog_avanzamento: false,
      dialog_chiusure_automatiche: false,
      dialog_comparazione_versioni: false,
      dialog_dettaglio_commessa: false,
      dialog_modifica_descrizione: false,
      dialog_note_commessa: false,
      dialog_personale_fasi: false,
      dialog_multiscelta: false,
      dialog_tabella_pezzi: false,
      dialog_tabella_tempi: false,
      gestione_allegati_visible: false,
      gestione_date: false,
      overlay: false,
      overlay_chiusura_massiva: false,
      overlay_gestione_date: false,
      overlay_scelta_articolo: false,
      scegli_mod_edit_ciclo_prod: false,
      visualizza_disegno_visible: false,

      // Array
      ciclo_lista: new Array(),
      ciclo_lista_clone: new Array(),
      headers_articoli: [
        {
          value: "modifica",
          text: "Scelta",
          sortable: false,
        },
        {
          text: "Cod. Articolo",
          value: "cod_articolo",
          sortable: false,
        },
        {
          text: "Des. articolo",
          value: "des_articolo",
          sortable: false,
        },
        {
          text: "Famiglia",
          value: "id_famiglia",
          sortable: false,
        },
        {
          text: "Numero d'Ordine",
          value: "des_aggiuntiva",
          sortable: false,
        },
      ],
      headers_articoli_aggiunta: [
        {
          value: "quantita",
          text: "Q.tà",
          sortable: false,
        },
        {
          text: "Cod. Articolo",
          value: "cod_articolo",
          sortable: false,
        },
        {
          text: "Des. articolo",
          value: "des_articolo",
          sortable: false,
        },
        {
          text: "Tipo",
          value: "id_tipo",
          sortable: false,
        },
        {
          text: "Famiglia",
          value: "id_famiglia",
          sortable: false,
        },
        {
          text: "Fornitura",
          value: "id_tipo_fornitura",
          sortable: false,
        },
      ],
      headers_carrello: [
        {
          text: "Start/Stop",
          sortable: false,
          value: "start_stop",
          class: "primary--text white",
        },
        {
          text: "Registra",
          sortable: false,
          value: "registra",
          class: "primary--text white",
        },
        {
          text: "Cod. Commessa",
          sortable: false,
          value: "cod_commessa",
          class: "primary--text white",
        },
        {
          text: "Cod. Articolo",
          sortable: false,
          value: "cod_articolo",
          class: "primary--text white",
        },
        {
          text: "Work Order",
          sortable: false,
          value: "cod_fase",
          class: "primary--text white",
        },
        {
          text: "Cod. Macchina",
          sortable: false,
          value: "cod_macchina",
          class: "primary--text white",
        },

        {
          text: "Lavorazione",
          sortable: false,
          value: "des_fase",
          class: "primary--text white",
        },
        {
          text: "Q.tà Totale",
          sortable: false,
          value: "quantita",
          class: "primary--text white",
        },
        {
          text: "Q.tà Prodotta",
          sortable: false,
          value: "pezzi_registrati",
          class: "primary--text white",
        },
        {
          text: "Q.tà Fase Precedente",
          sortable: false,
          value: "qta_precedente",
          class: "primary--text white",
        },
        {
          text: "Ora Start",
          sortable: false,
          value: "ora_start",
          class: "primary--text white",
        },
        {
          text: "Ora Stop",
          sortable: false,
          value: "ora_stop",
          class: "primary--text white",
        },

        {
          text: "Ore Registrate",
          sortable: false,
          value: "ore_produzione",
          class: "primary--text white",
        },
        {
          text: "Q.tà Registrata",
          sortable: false,
          value: "pezzi_produzione",
          class: "primary--text white",
        },
        {
          text: "Produzione Reale",
          sortable: false,
          value: "pzhreale",
          class: "primary--text white",
        },
        {
          text: "Tempo Ciclo",
          sortable: false,
          value: "tempo_ciclo",
          class: "primary--text white",
        },
        {
          text: "Nascondi",
          sortable: false,
          value: "nascondi",
          class: "primary--text white",
          align: "center",
        },
      ],
      headers_chiusure_automatiche: [
        {
          text: "Commessa",
          value: "cod_commessa",
          sortable: false,
        },
        { text: "Descrizione", value: "des_commessa", sortable: false },
        { text: "Chiusura Automatica", value: "selezionato", sortable: false },
      ],
      headers_ciclo: [
        {
          text: "Cod. Fase",
          sortable: false,
          value: "cod_fase",
        },
        {
          text: "Fase Lavoro",
          sortable: false,
          value: "des",
        },
        {
          text: "Personale",
          sortable: false,
          value: "personale_new",
        },
      ],
      headers_fasi_chiusura: [
        {
          text: "Cod. fase",
          sortable: false,
          value: "cod_fase",
        },
        {
          text: "Des. fase",
          sortable: false,
          value: "des",
        },
        {
          text: "Data Start",
          sortable: false,
          value: "data_start",
        },
        {
          text: "Ora Start",
          sortable: false,
          value: "ora_start",
        },
        {
          text: "Data Stop",
          sortable: false,
          value: "data_stop",
        },
        {
          text: "Ora Stop",
          sortable: false,
          value: "ora_stop",
        },
      ],
      items_articoli: new Array(),
      items_articoli_aggiunta: new Array(),
      items_capobarca: new Array(),
      items_chiusure_automatiche: new Array(),
      items_commesse_questionario: new Array(),
      items_commesse_pre_aggiunta: new Array(),
      items_distinta_base: new Array(),
      items_distinta_base_aggiunta: new Array(),
      items_fasi_chiusura: new Array(),
      items_stati_commessa: new Array(),
      items_tipo_articolo: new Array(),
      items_tipo_famiglia: new Array(),
      items_tipo_fornitura: new Array(),
      open: new Array(),
      personale_list: new Array(),
      tabella_distinta_bk: new Array(),
      tabella_modifica: new Array(),
    };
  },
  computed: {
    fstItemStatus() {
      if (this.items_distinta_base == null) {
        return null;
      } else if (this.items_distinta_base.length === 0) {
        return null;
      } else if (this.items_distinta_base[0].id_stato != null) {
        return this.items_distinta_base[0].id_stato;
      } else {
        return null;
      }
    },
    fstItmIsSuspOrAbort() {
      if (this.items_distinta_base == null) {
        return false;
      } else if (this.items_distinta_base.length === 0) {
        return false;
      } else if (
        this.items_distinta_base[0].id_stato ===
          this.id_stato_commessa_annullata ||
        this.items_distinta_base[0].id_stato === this.id_stato_commessa_sospesa
      ) {
        return true;
      } else {
        return false;
      }
    },
    data_commessa_formattata() {
      return this.data_commessa != ""
        ? moment(this.data_commessa).format("DD/MM/YYYY")
        : "";
    },
    data_consegna_formattata() {
      return this.data_consegna != ""
        ? moment(this.data_consegna).format("DD/MM/YYYY")
        : "";
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    async aggiornaRelazioniQuestionari() {
      /* Recupero l'id del questionario associato alla
       * commessa a cui ho appena aggiunto un componente. */
      if (this.id_art_inserimento_componente != null) {
        this.id_modulo_nuovi_componenti = await this.getModuloNuoviComponenti(
          this.id_comm_inserimento_componente
        );

        // Se qualcosa mi è andato storto nella chiamata mi fermo.
        if (this.id_modulo_nuovi_componenti == null) {
          return;
        }

        /* Faccio la cernita delle commesse che mi ero messo da parte
         * per capire quali sono quelle nuove rispetto a quelle che
         * avevo prima di effettuare l'inserimento in corsa. */
        const commesse_nuove_totali =
          this.items_distinta_base[0].children.filter(
            (c) => c.id_commessa == this.id_comm_inserimento_componente
          )[0].children;

        const commesse_nuove_relazioni = new Array();

        commesse_nuove_totali.forEach((cn) => {
          if (
            this.items_commesse_pre_aggiunta.filter(
              (cp) => cp.id_commessa == cn.id_commessa
            ).length == 0
          ) {
            commesse_nuove_relazioni.push({
              id_relazione: -1,
              id_riferimento: cn.id_commessa,
              id_modulo: this.id_modulo_nuovi_componenti,
              id_padre: cn.id_commessa_padre,
              riferimento: "commessa",
              pk_riferimento: "id_commessa",
              modulo: "questionario",
              pk_modulo: "id_questionario",
              obbligatorio: 1,
              multiplo: 0,
              validita: 1,
            });
          }
        });

        /* Ora ho i dati delle nuove commesse e del questionario associato
         * alla commessa padre, per cui faccio la chiamata per eseguire
         * l'associazione e parificare le relazioni delle commesse. */
        const request = {
          controller: "Global",
          method: "PUT",
          richiesta: {
            action: "updaterelazioni",
            token: localStorage.user_token,
            tabella: commesse_nuove_relazioni,
          },
        };

        this.$refs.SnackbarQV.print(
          "success",
          "Associazione del questionario al nuovo componente."
        );

        this.$store
          .dispatch("api", request)
          .then((res) => {
            if (res.status === 200) {
              this.getCommessaMultipla();
            } else {
              this.$refs.SnackbarQV.print(
                "orange",
                "Errore di comunicazione col server, non è stato possibile salvare i dati."
              );
            }
          })
          .catch((err) => {
            console.error(err);
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          });
      }
    },
    aggiungiNota(arg) {
      this.dialog_note_commessa = true;
      this.riga_sel.note = arg.note;
      this.riga_sel.id_stato = arg.id_stato;
      this.riga_sel.id_articolo = arg.id_commessa;
      this.riga_sel.id_commessa = arg.id_commessa;
      this.riga_sel.des_commessa = arg.des_commessa;
    },
    annullaChiudiWOMass() {
      this.conferma_chiudi_mass_wo = false;
      this.articolo_sel = new ArticoloClass();
    },
    apriDettaglioCommessa(arg) {
      this.riga_sel.id_commessa = arg.id_commessa;
      this.dialog_dettaglio_commessa = true;
    },
    async clickChiudiWOMulti(arg) {
      this.articolo_sel = new ArticoloClass(arg);

      // Popolo i dati per la finestra di dialogo di chiusura.
      await this.getWOChiusura();

      this.conferma_chiudi_mass_wo = true;
    },
    chiudiAssociazioni() {
      this.dialog_associazioni_questionario = false;
      this.getCommessaMultipla();
    },
    chiudiChiusureAutomatiche() {
      // Chiudo la finestra di dialogo.
      this.dialog_chiusure_automatiche = false;

      // Aggiorno la lista delle commesse.
      this.getCommessaMultipla();
    },
    chiudiCicloFasiArticolo() {
      // Chiudo il dialog di modifica
      this.ciclo_fasi_articolo = false;

      // Faccio una chiamata di aggiornamento
      this.getCommessaMultipla();
    },
    chiudiCicloFasiCommessa() {
      // Chiudo il dialog di modifica
      this.ciclo_fasi_commessa = false;

      // Faccio una chiamata di aggiornamento
      this.getCommessaMultipla();
    },
    chiudiConfermaCommessaMultipla() {
      this.conferma_commessa_multipla = false;
      this.data_commessa = "";
      this.data_consegna = "";
    },
    chiudiCommessaQuestionarioEM() {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "chiudicommessaquestionarioem",
          token: localStorage.user_token,
          id_commessa: this.articolo_sel.id_commessa,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    chiudiComparazioneVersioni() {
      this.dialog_comparazione_versioni = false;
      this.getCommessaMultipla();
    },
    chiudiConfermaEliminazione() {
      this.conferma_elimina_articolo = false;
      this.articolo_sel = new ArticoloClass();
    },
    chiudiDialogCommessa() {
      // Chiudo il dialog e resetto le variabili di supporto interessate.
      this.dialog_aggiungi_multilevel = false;
      this.articolo_sel = new ArticoloClass();
      this.items_articoli_aggiunta = new Array();
    },
    chiudiDisegno() {
      // Chiudo il dialog di visualizzazione dei disegni.
      this.visualizza_disegno_visible = false;

      this.getCommessaMultipla();
    },
    chiudiMultiscelta() {
      /* Devo chiudere il dialog di selezione
       * dell'articolo da una lista di possibilità. */
      this.dialog_multiscelta = false;

      /* Resetto l'array degli articoli per non
       * pesare sulla RAM del browser senza motivo. */
      this.items_articoli = new Array();
    },
    chiudiWOMulti() {
      /* Controllo che tutti i WO nell'array dei WO da
       * chiudere abbiano l'ora di start e l'ora di stop. */

      if (
        this.items_fasi_chiusura.filter(
          (e) =>
            e.data_start == "" ||
            e.ora_start == "" ||
            e.data_stop == "" ||
            e.ora_stop == ""
        ).length > 0
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Tutti i WO devono avere una data e ora di start e stop."
        );
        return;
      }

      const arr_tmp = new Array();

      this.items_fasi_chiusura.forEach((f) => {
        const obj_tmp = new Object();
        obj_tmp.id_commessa = f.id_commessa;
        obj_tmp.id_commessa_dettaglio = f.id_commessa_dettaglio;
        obj_tmp.id_commessa_tempi = -1;
        obj_tmp.ora_inizio = `${f.data_start} ${f.ora_start}:00`;
        obj_tmp.ora_fine = `${f.data_stop} ${f.ora_stop}:00`;
        arr_tmp.push(obj_tmp);
      });

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "chiudimultiwocommessaitalproget",
          token: localStorage.user_token,
          id_commessa: this.articolo_sel.id_commessa,
          chiudi_commessa: this.id_stato_commessa_chiusa,
          tempi: arr_tmp,
        },
      };

      // Inserisco un overlay di caricamento.
      this.overlay_chiusura_massiva = true;

      this.$store
        .dispatch("api", request)
        .then(async (res) => {
          // Tolgo l'overlay di caricamento.
          this.overlay_chiusura_massiva = false;

          if (res.status === 200) {
            // Chiudo la finestra di dialogo delle dichiarazioni tempi.
            this.conferma_chiudi_mass_wo = false;

            // Analizzo la risposta per cercare eventuali commesse da chiudere.
            const arr_parenti_tmp = new Array();

            // Cerco le commesse parenti che possono essere chiuse.
            if (res.data.result.chiudi_padre === "True") {
              res.data.result.parenti.forEach((p) => {
                if (
                  p.id_commessa != this.articolo_sel.id_commessa &&
                  p.questionari_obbligatori == p.questionari_completati
                ) {
                  p.selezionato = 0;
                  arr_parenti_tmp.push(p);
                }
              });
            }

            /* Se ho trovato delle commesse da chiudere automaticamente
             * faccio scattare il dialog di selezione, altrimenti chiudo
             * la finestra di dialogo attuale e aggiorno la lista commesse. */
            if (arr_parenti_tmp.length > 0) {
              this.items_chiusure_automatiche = arr_parenti_tmp;
              this.dialog_chiusure_automatiche = true;
            } else {
              // Chiudo il dialog di conferma.
              this.conferma_chiudi_mass_wo = false;

              // Aggiorno i dati visualizzati.
              await this.getCommessaMultipla();
            }

            // Stampo una snackbar di conferma.
            this.$refs.SnackbarQV.print(
              "success",
              "Fasi commessa avanzate con successo."
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          // Tolgo l'overlay di caricamento.
          this.overlay_chiusura_massiva = false;

          // Stampo una snackbar di avviso.
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );

          // Stampo il log dell'errore in console.
          console.error(err);
        });
    },
    clickConsuntiviPezzi(arg) {
      this.articolo_sel = new ArticoloClass(arg);
      this.key_tabella_pezzi = this.key_tabella_pezzi === 0 ? 1 : 0;
      this.dialog_tabella_pezzi = true;
    },
    clickConsuntiviTempi(arg) {
      this.articolo_sel = new ArticoloClass(arg);
      this.key_tabella_tempi = this.key_tabella_tempi === 0 ? 1 : 0;
      this.dialog_tabella_tempi = true;
    },
    clickDuplicaArticolo() {
      this.conferma_duplica_dialog = true;
    },
    clickEliminaCommessa(arg) {
      this.riga_sel.id_stato = arg.id_stato;
      this.riga_sel.id_commessa = arg.id_commessa;
      this.conferma_elimina_commessa = true;
    },
    clickEliminaComponente(arg) {
      this.articolo_sel = new ArticoloClass(arg);
      this.conferma_elimina_articolo = true;
    },
    clickGeneraArticoloStandard() {
      this.conferma_nuovo_articolo_dialog = true;
    },
    clickGestioneAllegati(item) {
      this.articolo_sel = new ArticoloClass(item);
      this.gestione_allegati_visible = true;
    },
    clickModificaCommessa(arg) {
      this.articolo_sel = new ArticoloClass(arg);
      this.scegli_mod_edit_ciclo_prod = true;
    },
    clickPersonale(item) {
      this.getCicloFasi(item);
      this.getPersonale();
      this.dialog_personale_fasi = true;
    },
    clickPlay(arg) {
      this.articolo_sel = new ArticoloClass(arg);
      this.dialog_avanzamento = true;
    },
    async clickScegliArticolo(arg) {
      /* In questo momento l'utente ha selezionato un articolo
       *  da una lista e ne vuole vedere la distinta base. */
      this.id_articolo_sel = arg.id_articolo;

      /* Avvio l'overlay di caricamento all'interno
       * della finestra di dialogo di scelta. */
      this.overlay_scelta_articolo = true;

      // Ricerco l'articolo selezionato.
      await this.getCommessaMultipla();

      // Dopo la ricerca fermo l'overlay di caricamento
      this.overlay_scelta_articolo = false;

      // Chiudo il dialog di scelta.
      this.dialog_multiscelta = false;
    },
    clickSetStatoCommessa() {
      this.conferma_stato_commessa = true;
    },
    clickSpecifiche(item) {
      /* Controllo che ci siano disegni da
       * visualizzare (me ne accorgo perché se
       * non ci sono id_disegno == null). */
      if (item.id_disegno === null || item.id_disegno === undefined) {
        // Se non ci sono disegni lancio una snackber di errore
        this.$refs.SnackbarQV.print(
          "grey",
          `Non ci sono disegni da visualizzare.`
        );
      } else {
        // Se ci sono disegni apro il dialog dei disegni.
        if (item.view_disegno == 0) {
          /* Se il disegno non è ancora stato visualizzato mando
           * una chiamata al BE e apro il dialog. */
          let request = {
            controller: "Magazzino",
            method: "PUT",
            richiesta: {
              action: "setviewdisegno",
              token: localStorage.getItem("user_token"),
              id_commessa: item.id_commessa,
              id_disegno: item.id_disegno,
              flag_em: "1",
            },
          };

          this.$store
            .dispatch("api", request)
            .then((res) => {
              if (res.status === 200) {
                this.visualizza_disegno_visible = true;
                this.articolo_sel = Object.assign({}, item);
              } else {
                this.$refs.SnackbarQV.print(
                  "error",
                  `Non è stato possibile caricare i dati: codice errore ${res.status}.`
                );
              }
            })
            .catch((err) => {
              this.$refs.SnackbarQV.print(
                "orange",
                `${JSON.parse(err.response.data.message).result}.`
              );
            });
        } else {
          /* Se il disegno è già stato visualizzato apro
           * il dialog semplicementa, senza chiamare il BE. */
          this.visualizza_disegno_visible = true;
          this.articolo_sel = Object.assign({}, item);
        }
      }
    },
    closeArticolo() {
      this.articolo_dialog = false;
    },
    closeCheck() {
      this.check_dialog_visible = false;
    },
    closeDialogCicli() {
      this.ciclo_lista = [];
      this.dialog_personale_fasi = false;
    },
    confermaEseguiCheck(arg) {
      // Imposto i dati per lanciare il questionario.
      this.input_args.id_questionario = arg.id_modulo;
      this.input_args.titolo_exec_ori = 1;
      this.input_args.id_relazione = arg.id_relazione;
      this.input_args.id_relazione_log = arg.id_relazione_log;
      this.input_args.landing_page = "quiz_detail/" + arg.id_modulo;
      this.input_args.dizionario = Object.assign({}, this.articolo_sel);
      this.input_args.esterno = 1;

      this.key_check = this.key_check == 0 ? 1 : 0;

      /* Lancio il questionario e metto a false
       * l'eventuale finestra di dialogo per confermare
       * o negare la volontà dell'utente di rispondere
       * a un questionario opzionale. */
      this.check_dialog_visible = true;
      this.conferma_check_visible = false;
    },
    duplicaArticolo() {
      let search_Articolo = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "duplicatearticle",
          token: localStorage.getItem("user_token"),
          id_articolo: this.id_articolo_sel,
          id_commessa: this.items_distinta_base[0].id_commessa,
          cod_articolo: this.cod_articolo_duplicazione,
          des_aggiuntiva: this.des_aggiuntiva_duplicazione,
          des_articolo: this.des_articolo_duplicazione,
        },
      };
      // Attivo l'overlay di caricamento.
      this.overlay = true;
      // Eseguo la chiamata al BE
      this.$store
        .dispatch("api", search_Articolo)
        .then((res) => {
          this.cod_articolo_duplicazione = "";
          this.des_aggiuntiva_duplicazione = "";
          this.des_articolo_duplicazione = "";

          // Appena ricevo una risposta, blocco l'overlay di caricamento
          this.overlay = false;

          // Se la risposta è in stato 200...
          if (res.status === 200) {
            // ... Carico l'articolo che ho appena generato
            this.id_articolo_sel = res.data[0].id_articolo;
            this.des_aggiuntiva_articolo_sel = res.data[0].des_aggiuntiva;
            this.cod_articolo_sel = res.data[0].cod_articolo;
            this.getCommessaMultipla();
          } else {
            // Se invece non è in stato 200 stampo una snackbar di errore.
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità rilevata, non è stato possibile caricare i dati; codice errore: ${res.status}.`
            );
          }
        })
        .catch((err) => {
          this.cod_articolo_duplicazione = "";
          this.des_aggiuntiva_duplicazione = "";
          this.des_articolo_duplicazione = "";
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(err.response.data.message).result}`
          );
        });
    },
    editCicloArticolo() {
      // Chiudo il dialog di scelta
      this.scegli_mod_edit_ciclo_prod = false;

      /* Faccio una chiamata getarticoli per valorizzare la prop
       * dialog delle fasi dell'articolo. Se la chiamata ha
       * successo, faccio scattare il dialog delle fasi dell'articolo. */
      let search_Articolo = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoli",
          token: localStorage.getItem("user_token"),
          cod_articolo: this.articolo_sel.des_commessa.split(" - ")[0],
        },
      };

      // Faccio scattare l'overlay di caricamento
      this.overlay = true;

      // Eseguo la chiamata al BE
      this.$store
        .dispatch("api", search_Articolo)
        .then((res) => {
          this.overlay = false;

          if (res.status === 200) {
            // Se non ci sono risultati stampo una snackbar di avviso.
            if (res.data.lista.length === 0) {
              this.$refs.SnackbarQV.print(
                "orange",
                `Non sono stati trovati articoli corrispondenti ai criteri di ricerca.`
              );
            } else if (res.data.lista.length === 1) {
              /* Se c'è un risultato, mi prendo il dettaglio dell'articolo che mi serve come prop
               * e faccio scattare il dialog del ciclo fasi forzando il refresh del componente. */
              this.dettaglio_articolo = res.data.dettaglio[0];
              this.key_ciclo_articolo = this.key_ciclo_articolo === 0 ? 1 : 0;
              this.ciclo_fasi_articolo = true;
            } else {
              /* Se ci sono più risultati li carico in una tabella e
               * apro il dialog di scelta dell'articolo. */
              this.$refs.SnackbarQV.print(
                "orange",
                `Anomalia: sono stati trovati più articoli corrispondenti a questo codice articolo, impossibile identificare univocamente il ciclo fasi.`
              );
            }
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              `Criticità rilevata, non è stato possibile caricare i dati; codice errore: ${res.status}.`
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          if (err) {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità rilevata, non è stato possibile caricare i dati; codice errore.`
            );
          }
        });
    },
    async editCicloCommessa() {
      // Chiudo il dialog di scelta
      this.scegli_mod_edit_ciclo_prod = false;

      /* Faccio una chiamata per popolare il dialog
       * del ciclo produzione della commessa. */
      await this.getCommessaFull();

      /* Una volta che ho ricevuto la response, apro il dialog delle
       * fasi della commessa forzando l'aggiornamento del componente. */
      this.key_ciclo_commessa = this.key_ciclo_commessa === 0 ? 1 : 0;
      this.ciclo_fasi_commessa = true;
    },
    eliminaCommessa() {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessa",
          token: localStorage.getItem("user_token"),
          id_commessa: this.riga_sel.id_commessa,
          id_profilo: localStorage.id_profilo,
          id_articolo: this.riga_sel.id_articolo,
          tabella: [
            {
              commessa: [
                {
                  validita: 0,
                  id_stato: this.riga_sel.id_stato,
                  id_commessa: this.riga_sel.id_commessa,
                },
              ],
              commessa_dettaglio: [],
            },
          ],
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.conferma_elimina_commessa = false;
            this.getCommessaMultipla();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server. Non è stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server. Non è stato possibile salvare i dati."
          );
        });
    },
    eliminaComponente() {
      this.overlay = true;
      this.articolo_sel.children = [];
      this.articolo_sel.validita = 0;
      this.articolo_sel.id_articolo = this.articolo_sel.id_padre;

      // Ora ho l'array di distinta base da salvare, e compongo la request
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setarticolidistintabase",
          id_articolo: this.articolo_sel.id_articolo,
          token: localStorage.getItem("user_token"),
          distinta_base: [{ children: [this.articolo_sel] }],
        },
      };

      // Eseguo la chiamata al BE.
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;

          if (res.status === 200) {
            this.$refs.SnackbarQV.print(
              "success",
              `Aggiunta effettuata con successo!`
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità rilevata, non è stato possibile caricare i dati; codice errore: ${res.status}.`
            );
          }

          // Chiudo il dialog e resetto le variabili di supporto interessate.
          this.conferma_elimina_articolo = false;
          this.articolo_sel = new ArticoloClass();

          // Ricarico la distinta base aggiornata.
          this.getCommessaMultipla();
        })
        .catch((err) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    formatData(arg_data, arg_tipo = "full") {
      if (arg_data == null || arg_data == "") {
        return "N/D";
      } else {
        if (arg_tipo == "full") {
          let strRes = "";
          strRes += arg_data.substr(8, 2);
          strRes += "/";
          strRes += arg_data.substr(5, 2);
          strRes += "/";
          strRes += arg_data.substr(0, 4);
          strRes += " ";
          strRes += arg_data.substr(11, 8);
          return strRes;
        } else if (arg_tipo == "strict") {
          let strRes = "";
          strRes += arg_data.substr(8, 2);
          strRes += "/";
          strRes += arg_data.substr(5, 2);
          strRes += "/";
          strRes += arg_data.substr(0, 4);
          strRes += " ";
          return strRes;
        }
      }
    },
    formatOra(arg) {
      return arg;
    },
    generaArticoloStandard() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoli",
          token: localStorage.user_token,
          cod_articolo: "ArticoloStandard00",
          validita: 1,
          firma: "Q0UV9svfLzgbzbwbUZbmM21n7q9W9B2NfIxxe7fUyrg=",
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.lista && res.data.lista[0]) {
              const art_std = res.data.lista[0];

              let search_Articolo = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                  action: "duplicatearticle",
                  token: localStorage.getItem("user_token"),
                  id_articolo: art_std.id_articolo,
                  cod_articolo: this.cod_articolo_duplicazione,
                  des_aggiuntiva: this.des_aggiuntiva_duplicazione,
                  des_articolo: this.des_articolo_duplicazione,
                },
              };
              // Attivo l'overlay di caricamento.
              this.overlay = true;
              this.$store
                .dispatch("api", search_Articolo)
                .then((res) => {
                  this.overlay = false;
                  this.cod_articolo_duplicazione = "";
                  this.des_aggiuntiva_duplicazione = "";
                  this.des_articolo_duplicazione = "";

                  // Se la risposta è in stato 200...
                  if (res.status === 200) {
                    this.$refs.SnackbarQV.print(
                      "success",
                      `Articolo generato con successo.`
                    );
                  } else {
                    // Se invece non è in stato 200 stampo una snackbar di errore.
                    this.$refs.SnackbarQV.print(
                      "orange",
                      `Criticità rilevata, non è stato possibile caricare i dati; codice errore: ${res.status}.`
                    );
                  }
                })
                .catch((err) => {
                  this.cod_articolo_duplicazione = "";
                  this.des_aggiuntiva_duplicazione = "";
                  this.des_articolo_duplicazione = "";
                  this.overlay = false;
                  this.$refs.SnackbarQV.print(
                    "orange",
                    `${JSON.parse(err.response.data.message).result}`
                  );
                });
            } else {
              this.$refs.SnackbarQV.print(
                "orange",
                "Non c'è nessun articolo con codice ArticoloStandard00."
              );
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          console.error(err);
        });
    },
    getArticoli() {
      this.overlay = true;

      // Controllo che qualcuno dei campi sia valorizzato
      if (
        this.cod_articolo_sel === "" &&
        this.tipo_famiglia_sel === null &&
        this.des_aggiuntiva_articolo_sel === ""
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Specificare dei parametri di ricerca."
        );
      }

      let search_Articolo = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoli",
          token: localStorage.getItem("user_token"),
          cod_articolo: this.cod_articolo_sel || "",
          des_aggiuntiva: this.des_aggiuntiva_articolo_sel || "",
          id_tipo: this.tipo_articolo_sel || "",
          id_famiglia: this.tipo_famiglia_sel || "",
        },
      };

      // Eseguo la chiamata al BE
      this.$store
        .dispatch("api", search_Articolo)
        .then((res) => {
          this.overlay = false;

          if (res.status === 200) {
            // Se non ci sono risultati stampo una snackbar di avviso.
            if (res.data.lista.length === 0) {
              this.$refs.SnackbarQV.print(
                "orange",
                `Non sono stati trovati articoli corrispondenti ai criteri di ricerca.`
              );
            } else if (res.data.lista.length === 1) {
              // Se c'è un risultato, ne carico la distinta base.
              this.id_articolo_sel = res.data.lista[0].id_articolo;
              this.getCommessaMultipla();
            } else {
              /* Se ci sono più risultati li carico in una tabella e
               * apro il dialog di scelta dell'articolo. */
              this.items_articoli = Array.from(res.data.lista);
              this.dialog_multiscelta = true;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              `Criticità rilevata, non è stato possibile caricare i dati; codice errore: ${res.status}.`
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    getArticoliAggiunta() {
      this.overlay = true;

      // Controllo che qualcuno dei campi sia valorizzato
      if (
        this.cod_articolo_sel === "" &&
        this.tipo_articolo_sel === null &&
        this.tipo_famiglia_sel === null &&
        this.tipo_fornitura_sel === null
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Specificare dei parametri di ricerca."
        );
      }

      let search_Articolo = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoli",
          token: localStorage.getItem("user_token"),
          cod_articolo: this.cod_articolo_sel_aggiunta || "",
          id_tipo: this.tipo_articolo_sel_aggiunta || "",
          id_famiglia: this.tipo_famiglia_sel_aggiunta || "",
          id_tipo_fornitura: this.tipo_fornitura_sel_aggiunta || "",
        },
      };

      // Eseguo la chiamata al BE
      this.$store
        .dispatch("api", search_Articolo)
        .then((res) => {
          this.overlay = false;

          if (res.status === 200) {
            // Se non ci sono risultati stampo una snackbar di avviso.
            if (res.data.lista.length === 0) {
              this.$refs.SnackbarQV.print(
                "orange",
                `Non sono stati trovati articoli corrispondenti ai criteri di ricerca.`
              );
            } else {
              // Se ci sono dei risultati li carico nella tabella debita
              this.items_articoli_aggiunta = Array.from(
                res.data.lista.filter(
                  /* Escludo dagli oggetti da caricare quello che ha
                   * lo stesso id_articolo della tabella selezionata. */
                  (e) => e.id_articolo != this.articolo_sel.id_articolo
                )
              );

              this.items_articoli_aggiunta.forEach((e) => {
                e.quantita = 0;
              });
            }
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              `Criticità rilevata, non è stato possibile caricare i dati; codice errore: ${res.status}.`
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    getCicloFasi(arg) {
      this.overlay = true;
      let richiesta = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessafull",
          token: localStorage.getItem("user_token"),
          id_commessa: arg.id_commessa,
          id_profilo: localStorage.id_profilo,
        },
      };

      this.$store.dispatch("api", richiesta).then((res) => {
        this.commessa = res.data;
        this.ciclo_lista = res.data.commessa_dettaglio;
        this.ciclo_lista_clone = JSON.parse(
          JSON.stringify(res.data.commessa_dettaglio)
        );
        this.ciclo_lista.forEach((e) => {
          e.personale_new = [];
          if (e.commessa_dettaglio_personale.length > 0) {
            e.commessa_dettaglio_personale.forEach((p) => {
              let obj_personale = {
                id_utente: p.id_personale,
                nominativo: p.nominativo,
              };
              e.personale_new.push(obj_personale);
            });
          }
        });
      });
      this.overlay = false;
    },
    getPersonale() {
      let richiesta = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getutenti",
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store.dispatch("api", richiesta).then((res) => {
        this.personale_list = res.data;
      });
    },
    getCommessaFull() {
      let getcommessa = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessafull",
          token: localStorage.getItem("user_token"),
          id_commessa: this.articolo_sel.id_commessa,
          id_profilo: localStorage.id_profilo,
        },
      };

      return this.$store.dispatch("api", getcommessa).then((res) => {
        this.dati_ciclo = res.data;
      });
    },
    async getCommessaMultipla() {
      this.overlay = true;

      const getcommessamultipla = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessamultiplanew",
          token: localStorage.getItem("user_token"),
          id_articolo: this.id_articolo_sel,
          flag_produzione: 1,
          flag_check_utente: 0,
        },
      };

      return this.$store
        .dispatch("api", getcommessamultipla)
        .then(async (res) => {
          this.overlay = false;

          if (res.status === 200) {
            // Resetto l'array di backup della distinta
            this.tabella_distinta_bk = [];

            /* Valorizzo le variabili di supporto come
             * mi serve per l'operatività del sistema. */
            const my_array = [];
            for (let i = 0; i < res.data.result.length; i++) {
              /* Creo dei campi qtaTotale_originale e qtaTotale_somma che mi
               * torneranno utili in seguito per calcolare la quantità di
               * oggetti da produrre. */
              this.tabella_distinta_bk.push(_.cloneDeep(res.data.result[i]));
              let o = _.cloneDeep(res.data.result[i]);
              o.qtaTotale_originale = o.quantita == null ? 1 : o.quantita;
              o.qtaTotale_somma = 0;
              my_array.push(_.cloneDeep(o));
            }

            // Verifico il flag revisionato dell'elemento capostipite
            // const rv = await this.getRevisioneVisualizzata(my_array[0]);

            let arr_tmp = new Array();
            this.open = new Array();
            this.setAnnidamentoRecursivo(my_array, arr_tmp, 1, 0);

            /* Assegno un indice a tutti gli elementi di "arr_tmp"
             * e ai loro figli per stampare il numero di riga nella treeview. */
            this.setIndiceRicorsivo(arr_tmp);

            /* Assegno il flag revisione_visualizzata che ho valorizzato
             * poche righe sopra; valorizzare prima, e poi assegnare il flag in
             * due battute è necessario per una questione di millisecondi e puntatori,
             * altrimenti gli identificativi dei nodi non vengono inseriti nell'array
             * open e la treeview non viene espansa al primo colpo. */
            this.id_capobarca_sel =
              arr_tmp[0].id_responsabile != undefined
                ? arr_tmp[0].id_responsabile
                : null;

            this.items_distinta_base = Array.from(arr_tmp);

            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità rilevata, non è stato possibile caricare i dati; codice errore: ${res.status}.`
            );

            return false;
          }
        })
        .catch((e) => {
          this.overlay = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            `Errore di comunicazione col server, non è stato possibile caricare i dati.`
          );

          return false;
        });
    },
    getDistintaBaseAggiunta() {
      /* Questa chiamata serve per mettermi da parte la distinta
       * base dell'articolo a cui voglio aggiungere dei componenti. */

      this.overlay = true;

      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticolidistintabase",
          token: localStorage.getItem("user_token"),
          id_articolo: this.articolo_sel.id_articolo,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;

          /* Resetto l'articolo_sel in caso questa chiamata sia stata fatta
           * per eseguire un refresh deidati dopo selezione (per esempio è
           * quello che succede nella procedura di eliminazione da distinta base). */
          // this.articolo_sel = new ArticoloClass();

          if (res.status === 200) {
            this.items_distinta_base_aggiunta = Array.from(res.data);
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              `Criticità rilevata, non è stato possibile caricare i dati; codice errore: ${res.status}.`
            );
          }

          /* Assegno un indice a tutti gli elementi di "items_distinta_base"
           * e ai loro figli per stampare il numero di riga nella treeview. */
          this.setIndiceRicorsivo(this.items_distinta_base_aggiunta);
        })
        .catch((err) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    getModuloNuoviComponenti(arg_id_commessa) {
      const request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "getrelazionimoduli",
          token: localStorage.user_token,
          id_riferimento: arg_id_commessa,
          id_personale: localStorage.id,
          riferimento: "commessa",
          modulo: "questionario",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (
              res.data.result &&
              res.data.result.tabella &&
              res.data.result.tabella[0]
            ) {
              return res.data.result.tabella[0].id_modulo;
            } else {
              return null;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return null;
          }
        })
        .catch((err) => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          console.error(err);
          return null;
        });
    },
    getRelazioniModuli(id_commessa) {
      const request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "getrelazionimoduli",
          token: localStorage.user_token,
          id_riferimento: id_commessa,
          id_personale: localStorage.id,
          riferimento: "commessa",
          modulo: "questionario",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.result.dati.length > 0) {
              let object = {
                id_relazione: res.data.result.dati[0].id_relazione,
                id_modulo: res.data.result.dati[0].id_start,
                exec: res.data.result.dati[0]._exec,
                id_relazione_log: res.data.result.dati[0].id_relazione_log,
              };
              return object;
            } else {
              return {
                exec: "N",
              };
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    getRevisioneVisualizzata(arg) {
      this.overlay = true;

      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getrevisionevisualizzata",
          token: localStorage.getItem("user_token"),
          des_aggiuntiva: arg.des_aggiuntiva,
          id_commessa: arg.id_commessa,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;

          if (res.status === 200) {
            return res.data.result;
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              `Criticità rilevata, non è stato possibile caricare i dati; codice errore: ${res.status}.`
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    getTabelle() {
      this.overlay = true;

      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "'Famiglia','FORNITURA_STANDARD','TIPOARTICOLO', 'COMMESSA_STATO'",
          filter: "validita = 1",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;

          this.items_tipo_articolo =
            res.data.TIPOARTICOLO != undefined ? res.data.TIPOARTICOLO : [];
          this.items_tipo_famiglia =
            res.data.Famiglia != undefined ? res.data.Famiglia : [];
          this.items_tipo_fornitura =
            res.data.FORNITURA_STANDARD != undefined
              ? res.data.FORNITURA_STANDARD
              : [];

          /* Registro gli id_tabella di COMMESSA_STATO
           * che mi servono per le icone delle commesse. */
          if (res.data.COMMESSA_STATO != undefined) {
            this.items_stati_commessa = new Array();

            res.data.COMMESSA_STATO.forEach((e) => {
              if (e.val_txt == 1) {
                this.id_stato_commessa_creata = e.id_tabella;
                this.items_stati_commessa.push(Object.assign({}, e));
              } else if (e.val_txt == 2) {
                this.id_stato_commessa_aperta = e.id_tabella;
                this.items_stati_commessa.push(Object.assign({}, e));
              } else if (e.val_txt == 3) {
                this.id_stato_commessa_chiusa = e.id_tabella;
                this.items_stati_commessa.push(Object.assign({}, e));
              } else if (e.val_txt == 4) {
                this.id_stato_commessa_sospesa = e.id_tabella;
                this.items_stati_commessa.push(Object.assign({}, e));
              } else if (e.val_txt == 5) {
                this.id_stato_commessa_annullata = e.id_tabella;
                this.items_stati_commessa.push(Object.assign({}, e));
              }
            });
          }
        })
        .catch((err) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    getTeam() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getteam",
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_capobarca = _.cloneDeep(res.data.Responsabili);
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore nello scambio di dati col server."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore nello scambio di dati col server."
          );
        });
    },
    getWOChiusura() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getworkorders",
          token: localStorage.getItem("user_token"),
          id_articolo: this.articolo_sel.id_articolo,
          cod_commessa: this.articolo_sel.cod_commessa,
          filtroEM: "1",
        },
      };

      this.overlay = true;

      this.$store
        .dispatch("api", request)
        .then((res) => {
          // Fermo l'overlay di caricamento.
          this.overlay = false;

          if (res.status === 200) {
            // Svuoto l'array che contiene i WO da chiudere.
            this.items_fasi_chiusura = new Array();

            /* Metto fra i WO da chiudere solo quelli che non hanno
             * ancora raggiunto la quantità richiesta dalla commessa. */
            res.data
              .filter((e) => e.pezzi_registrati < e.quantita)
              .forEach((elem) => {
                if (elem.pezzi_registrati < elem.quantita) {
                  elem.data_start = moment().format("YYYY-MM-DD");
                  elem.ora_start = "";
                  elem.data_stop = moment().format("YYYY-MM-DD");
                  elem.ora_stop = "";
                  elem.calendario_data_start = false;
                  elem.calendario_data_stop = false;
                  elem.calendario_ora_start = false;
                  elem.calendario_ora_start = false;
                  this.items_fasi_chiusura.push(elem);
                }
              });

            return true;
          } else {
            this.overlay = false;
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );

            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );

          return false;
        });
    },
    goBack() {
      if (this.back_as_landing_page === false) {
        this.$emit("chiudi_dialog");
      } else if (this.back_as_landing_page === true) {
        this.$emit("go_back");
      }
    },
    async handleClickCheck(arg) {
      /* Se è stata cliccata una commessa chiusa, non faccio una chiamata
       * al BE per sapere se devo compilare il questionario perché il fatto
       * che la commessa sia in stato chiuso significa che qualcuno ha già
       * risposto a un questionario per questa commessa e ciò mi basta. */
      if (
        arg.questionario_completato == 1 ||
        arg.id_stato === this.id_stato_commessa_chiusa
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non risultano esserci questionari da compilare."
        );
        return;
      }

      // Registro il WO cliccato.
      this.articolo_sel = new ArticoloClass(arg);

      /* Mi metto da parte l'oggetto che contiene le
       * informazioni sul questionario a cui devo rispondere. */
      const getrelazioni_tmp = await this.getRelazioniModuli(arg.id_commessa);

      /* In base alla risposta del server, decido come regolare
       * il comportamento della logica di QuickCheck. */
      switch (getrelazioni_tmp.exec) {
        case "S":
          // Lancio il questionario di QuickCheck.
          this.confermaEseguiCheck(getrelazioni_tmp);
          break;
        case "N":
          this.$refs.SnackbarQV.print(
            "orange",
            "Non risultano esserci questionari da compilare."
          );
          break;
        case "X":
          /* Potrei rispondere al questionario: apro
           * la finestra di dialogo e mi metto da parte
           * il metodo che dovrebbe essere eseguito. Se
           * l'utente dice che non vuole eseguire il
           * questionario, lancio il metodo che mi sono
           * messo da parte. */
          this.conferma_check_visible = true;
          break;
        default:
          this.$refs.SnackbarQV.print(
            "orange",
            "Non risultano esserci questionari da compilare."
          );
          break;
      }
    },
    handleClickIndietro() {
      this.dialog_avanzamento = false;
      this.getCommessaMultipla();
    },
    async handleFineSessione(arg) {
      if (arg.punteggio == null) {
        this.$refs.SnackbarQV.print("orange", "Questionario sospeso!");
      } else if (arg.punteggio < 100) {
        this.$refs.SnackbarQV.print(
          "orange",
          `Questionario completato con punteggio non ottimale.`
        );

        await this.chiudiCommessaQuestionarioEM();
        this.getCommessaMultipla();
      } else if (arg.punteggio == 100) {
        this.$refs.SnackbarQV.print("success", `Questionario completato.`);

        await this.chiudiCommessaQuestionarioEM();
        this.getCommessaMultipla();
      }

      this.check_dialog_visible = false;
    },
    handleKeydown(e, tipo) {
      if (
        e.code === "Enter" &&
        this.cod_articolo_sel != "" &&
        tipo === "getArticoli"
      ) {
        this.getArticoli();
      } else if (
        e.code === "Enter" &&
        this.cod_articolo_sel != "" &&
        tipo === "getArticoliAggiunta"
      ) {
        this.getArticoliAggiunta();
      }
    },
    inserisciComponente(arg) {
      /* Se si tratta di una commessa registro il suo id e
       * le sue sottocommesse, perché ne avrò bisogno per
       * collegare il questionario dopo l'inserimento in cosra. */
      if (arg.id_commessa) {
        /* Registro l'id del padre in cui
         * deve essere inserito un componente. */
        this.id_art_inserimento_componente = arg.id_articolo;
        this.id_comm_inserimento_componente = arg.id_commessa;

        /* Registro le commesse figlie della
         * commessa che sto modificando. */
        this.items_commesse_pre_aggiunta = arg.children;
      }

      // Registro l'articolo selezionato.
      this.articolo_sel = new ArticoloClass(arg);

      // Registro la distinta base dell'articolo che ho selezionato.
      this.getDistintaBaseAggiunta();

      // Apro il dialog.
      this.dialog_aggiungi_multilevel = true;
    },
    modificaDescrizioneCommessa(arg) {
      this.dialog_modifica_descrizione = true;
      this.riga_sel.note = "";
      this.riga_sel.id_stato = arg.id_stato;
      this.riga_sel.id_articolo = arg.id_commessa;
      this.riga_sel.id_commessa = arg.id_commessa;
      this.riga_sel.des_commessa = arg.des_commessa;
    },
    openArticolo() {
      this.articolo_dialog = true;
      this.key_articolo = this.key_articolo == 0 ? 1 : 0;
    },
    openAssociazioneQuestionario(arg) {
      this.articolo_sel = new ArticoloClass(arg);
      this.items_commesse_questionario = new Array();

      /* Preparo un oggetto che rappresenta la
       * commessa principale su cui ho cliccato. */
      const commessa_principale = new ArticoloClass(arg);

      /* Inserisco la commessa pricipale nell'array delle commesse
       * passibili di essere collegate a dei questionari. */
      this.items_commesse_questionario.push(commessa_principale);

      /* Aggiungo all'array delle commesse passibili di associazione
       * a dei questionari tutte le commesse figlie della commessa
       * principale. */
      arg.children.forEach((c) => {
        this.items_commesse_questionario.push(c);
      });

      this.dialog_associazioni_questionario = true;
    },
    openComparisonByVersions(arg) {
      this.articolo_sel = new ArticoloClass(arg);
      this.dialog_comparazione_versioni = true;
      this.$nextTick(function () {
        this.$refs.ComparazioneVersioni.codice_search = arg.des_aggiuntiva;
        this.$refs.ComparazioneVersioni.multiple = true;
        setTimeout(() => {
          this.$refs.ComparazioneVersioni.compareVersion();
        }, 10);
      });
    },
    openGestisciDate(arg) {
      // Registro l'articolo cliccato.
      this.articolo_sel = new ArticoloClass(arg);

      // Registro le date di commessa / consegna.
      this.data_commessa = this.articolo_sel.data_commessa
        ? moment(this.articolo_sel.data_commessa.substr(0, 10)).format(
            "YYYY-MM-DD"
          )
        : moment().format("YYYY-MM-DD");
      this.data_consegna = this.articolo_sel.data_consegna
        ? moment(this.articolo_sel.data_consegna.substr(0, 10)).format(
            "YYYY-MM-DD"
          )
        : moment().format("YYYY-MM-DD");

      // Apro la finestra di dialogo.
      this.gestione_date = true;
    },
    popolaArrayEliminazione(arg) {
      this.tabella_modifica.push(arg.id_commessa);
      if (arg.children) {
        arg.children.forEach((c) => {
          this.popolaArrayEliminazione(c);
        });
      }
    },
    async salvaAggiuntaDistinta() {
      this.overlay = true;

      /* Costruisco un array che userò per valorizzare
       * eventualmente l'argomento della chiamata per creare
       * una commessa dopo aver modificato la distinta base. */
      let arr_for_commessa = new Array();

      /* Mi faccio un flag per rilevare se ho modificato la quantità
       * di qualche componente che era già presente in distinta. */
      let flag_qta_aggiornata = false;

      /* Faccio una chiamata  */
      let nuova_distinta_base = Array.from(this.items_distinta_base_aggiunta);
      this.items_articoli_aggiunta.forEach((e) => {
        // Trasformo la quanitità da stringa (eventuale) in numero.
        e.quantita = parseInt(e.quantita);

        /* Se la quantità del componente è maggiore
         * di 0 lo gestisco, altrimenti lo ignoro. */
        if (e.quantita > 0) {
          // Verifico che il componente non ricorra già nella distinta base
          nuova_distinta_base.forEach((c) => {
            if (c.id_componente === e.id_articolo) {
              // Se il componente ricorre, gli cambio semplicemente la quantità
              c.quantita = parseInt(e.quantita);
              flag_qta_aggiornata = true;
            } else {
              // Se invece l'articolo non ricorre già come componente...

              // Costruisco un nuovo componente
              const nuovo_componente = {};
              nuovo_componente.children = [];
              nuovo_componente.cod_articolo = e.cod_articolo;
              nuovo_componente.des_articolo = e.des_articolo;
              nuovo_componente.id = e.id_articolo;
              nuovo_componente.id_articolo = this.articolo_sel.id_articolo;
              nuovo_componente.id_componente = e.id_articolo;
              nuovo_componente.id_distinta_base = -1;
              nuovo_componente.id_rif = 0;
              nuovo_componente.name = e.cod_articolo;
              nuovo_componente.quantita = e.quantita;
              nuovo_componente.validita = 1;

              // Aggiungo il nuovo componente alla distinta base.
              nuova_distinta_base[0].children.push(
                Object.assign({}, nuovo_componente)
              );

              /* Registro questo componente che mi può servire in
               * seguito per creare una commessa dopo il cambiamento
               * della distinta base. */
              arr_for_commessa.push(Object.assign({}, nuovo_componente));
            }
          });
        }
      });

      /* Setto la validità del primo livello di
       * distinta base a 1 per convenienza di BE. */
      nuova_distinta_base[0].validita = 1;

      /* Azzero l'array dei children di tutti i figli di
       * primo livello del primo oggetto della distinta base.*/
      nuova_distinta_base[0].children.forEach((c) => {
        c.children = [];
      });

      // Ora ho l'array di distinta base da salvare, e compongo la request
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setarticolidistintabase",
          id_articolo: this.articolo_sel.id_articolo,
          token: localStorage.getItem("user_token"),
          distinta_base: nuova_distinta_base,
        },
      };

      // Eseguo la chiamata al BE.
      this.$store
        .dispatch("api", request)
        .then(async (res) => {
          this.overlay = false;

          if (res.status === 200) {
            if (flag_qta_aggiornata === true) {
              this.$refs.SnackbarQV.print(
                "success",
                `Distinta base salvata, le quantità dei componenti già presenti sono state aggiornate!`
              );
            } else {
              this.$refs.SnackbarQV.print(
                "success",
                `Aggiunta effettuata con successo!`
              );
            }

            /* Se le seguenti condizioni sono verificate significa che
             * sto avanzando una commessa; in questo caso oltre ad aggiungere
             * un elemento alla distinta base devo fare una chiamata in coda
             * per generare la commessa dell'articolo che ho aggiunto. */
            if (
              this.items_distinta_base[0].id_commessa != undefined &&
              this.items_distinta_base[0].id_commessa != null
            ) {
              await this.setCommessaInCorsa(arr_for_commessa);
            }

            // Chiudo il dialog e resetto le variabili di supporto interessate.
            this.dialog_aggiungi_multilevel = false;
            this.articolo_sel = new ArticoloClass();
            this.items_articoli_aggiunta = new Array();

            // Ricarico la distinta base aggiornata.
            await this.getCommessaMultipla();

            /* Dopo aver aggiunto le eventuali commesse in corsa,
             * uso i dati della commessa principale a cui ho
             * aggiunto dei componenti e dei componenti che aveva
             * originariamente per generare le nuove associazioni
             * fra il questionario associato alla commessa padre
             * e le sottocommesse appena generate. Se ho aggiunto
             * un elemento alla distinta base e non a una commessa
             * il metodo lo capisce e non esegue chiamate. */
            this.aggiornaRelazioniQuestionari();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità rilevata, non è stato possibile caricare i dati; codice errore: ${res.status}.`
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },
    salvaChiusureCommesse() {
      // Controllo che ci siano commesse da salvare.
      if (
        this.items_chiusure_automatiche.filter((e) => e.selezionato == 1)
          .length == 0
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Selezionare almeno una commessa da chiudere."
        );
        return;
      }

      // Metto da parte le commesse da chiudere e le formatto.
      const commesse_tmp = new Array();

      this.items_chiusure_automatiche.forEach((c) => {
        if (c.selezionato == 1) {
          commesse_tmp.push(c.id_commessa);
        }
      });

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessestato",
          token: localStorage.user_token,
          tabella: commesse_tmp,
          id_tabella: this.id_stato_commessa_chiusa,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            /* Chiudo la finestra di dialogo di selezione
             * e aggiorno la lista delle commesse. */
            this.dialog_chiusure_automatiche = false;
            this.getCommessaMultipla();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    salvaModificaDescrizione() {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessa",
          token: localStorage.getItem("user_token"),
          id_commessa: this.riga_sel.id_commessa,
          id_profilo: localStorage.id_profilo,
          id_articolo: this.riga_sel.id_articolo,
          tabella: [
            {
              commessa: [
                {
                  des_commessa: this.riga_sel.des_commessa,
                  id_stato: this.riga_sel.id_stato,
                  note: this.riga_sel.note,
                  id_commessa: this.riga_sel.id_commessa,
                },
              ],
              commessa_dettaglio: [],
            },
          ],
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.dialog_modifica_descrizione = false;
            this.getCommessaMultipla();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server. Non è stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server. Non è stato possibile salvare i dati."
          );
        });
    },
    salvaNoteCommessa() {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessa",
          token: localStorage.getItem("user_token"),
          id_commessa: this.riga_sel.id_commessa,
          id_profilo: localStorage.id_profilo,
          id_articolo: this.riga_sel.id_articolo,
          tabella: [
            {
              commessa: [
                {
                  des_commessa: this.riga_sel.des_commessa,
                  id_stato: this.riga_sel.id_stato,
                  note: this.riga_sel.note,
                  id_commessa: this.riga_sel.id_commessa,
                },
              ],
              commessa_dettaglio: [],
            },
          ],
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.dialog_note_commessa = false;
            this.getCommessaMultipla();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server. Non è stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server. Non è stato possibile salvare i dati."
          );
        });
    },
    salvaPersonale() {
      this.personale_dialog = false;

      const request = {
        controller: "Manutenzione",
        method: "PUT",
        richiesta: {
          action: "setpersonale",
          token: localStorage.user_token,
          id_ciclo: this.articolo_sel.id_ciclo,
          id_ciclo_fasi: this.articolo_sel.id_ciclo_fasi,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            // Stampo una snackbar di conferma.
            this.$refs.SnackbarQV.print(
              "success",
              "La risorsa è stata associata alla commessa."
            );

            // Ricarico i dati.
            this.getCommessaMultipla();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Errore nella comunicazione con il server: codice ${res.status}.`
            );
          }
        })
        .catch((err) => {
          if (err) {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore critico nella comunicazione con il server."
            );
          }
        });
    },
    saveGestisciDate() {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessa",
          token: localStorage.user_token,
          tabella: [
            {
              commessa: [
                {
                  id_commessa: this.articolo_sel.id_commessa,
                  id_stato: this.articolo_sel.id_stato,
                  data_commessa: this.data_commessa,
                  data_consegna: this.data_consegna,
                },
              ],
              commessa_dettaglio: [],
            },
          ],
        },
      };

      this.overlay_gestione_date = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay_gestione_date = false;
          if (res.status === 200) {
            this.gestione_date = false;
            this.getCommessaMultipla();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay_gestione_date = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },
    setAnnidamentoRecursivo(a1, a2, val_livello, val_ricercato) {
      a1.forEach((i) => {
        if (i.id_commessa == undefined) {
          if (
            i.livello === val_livello &&
            (i.id_padre === val_ricercato ||
              (i.livello == 1 && i.id_padre == null && val_ricercato == 0))
          ) {
            const obj_tmp = _.cloneDeep(i);
            obj_tmp.id_tmp = "" + obj_tmp.id_articolo + obj_tmp.id_componente;
            this.open.push(obj_tmp.id_tmp);
            obj_tmp.children = [];
            this.setAnnidamentoRecursivo(
              a1,
              obj_tmp.children,
              val_livello + 1,
              i.id_articolo
            );
            a2.push(_.cloneDeep(obj_tmp));
          }
        } else {
          if (
            i.livello === val_livello &&
            (i.id_commessa_padre === val_ricercato ||
              (i.id_commessa_padre === null && val_ricercato === 0))
          ) {
            const obj_tmp = _.cloneDeep(i);
            obj_tmp.id_tmp =
              "" + obj_tmp.id_commessa + obj_tmp.id_commessa_padre;
            this.open.push(obj_tmp.id_tmp);
            obj_tmp.children = [];
            this.setAnnidamentoRecursivo(
              a1,
              obj_tmp.children,
              val_livello + 1,
              i.id_commessa
            );
            a2.push(_.cloneDeep(obj_tmp));
          }
        }
      });
    },
    setcapobarca() {
      if (this.id_capobarca_sel === null) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non è stato indicato un capobarca."
        );
      }

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setresponsabilecommessa",
          token: localStorage.user_token,
          id_commessa: this.items_distinta_base[0].id_commessa,
          id_responsabile: this.id_capobarca_sel,
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.$refs.SnackbarQV.print(
              "success",
              "Responsabile associato con successo."
            );
            this.overlay = false;
            this.getCommessaMultipla();
          } else {
            this.overlay = false;
            this.$refs.SnackbarQV.print(
              "orange",
              `Errore nello scambio di dati col server: ${res.status}.`
            );
          }
        })
        .catch(() => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            `Errore nello scambio di dati col server.`
          );
        });
    },
    setCommessa() {
      /* Forzo il tipo avanzamento a 3 perché ElectricalMarine
       * tratta tutte le commesse come se avessero il tipo
       * di avanzamento "Produzione a Magazzino". */
      const obj_tmp = JSON.parse(
        JSON.stringify(this.$refs.CommessaCicloProdNew.cicloData)
      );
      obj_tmp.tipo_avanzamento = 3;

      // Compongo la request.
      let setcommessa = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessa",
          token: localStorage.getItem("user_token"),
          id_commessa: this.articolo_sel.id_commessa,
          id_articolo: this.articolo_sel.id_articolo,
          id_profilo: localStorage.id_profilo,
          tabella: [obj_tmp],
        },
      };
      this.$store.dispatch("api", setcommessa).then((res) => {
        if (res.status === 200) {
          this.ciclo_fasi_commessa = false;
          this.getCommessaMultipla();
        }
      });
    },
    setCommessaInCorsa(arg_arr) {
      const arr_tmp = _.cloneDeep(arg_arr);
      arr_tmp.forEach((e) => {
        /* Assegno a questa commessa lo stesso capobarca
         * delle altre commesse e sotto-commesse. */
        e.id_responsabile = this.id_capobarca_sel;
        // Aggiungo dei campi per convenienza di BE
        e.qtaTotale_originale = e.quantita;
        e.qtaTotale = e.quantita == null ? 1 : e.quantita;
        e.chkgenera = 1;
      });

      this.overlay = true;

      /* Porto in stringa le quantità di ogni commessa, altrimenti
       * il BE quando applica Newtonsoft.JSONconvert.DeserializeObject
       * disuo arrotonderebbe male i numeri in virgola mobile. */
      arr_tmp.forEach((e) => {
        e.quantita = e.quantita + "";
        e.qtaTotale = e.qtaTotale + "";
        e.qtaTotale_originale = e.qtaTotale_originale + "";
      });

      const setcommessamultipla = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessamultipla",
          token: localStorage.getItem("user_token"),
          cod_articolo: this.cod_articolo_sel,
          id_commessa_avo: this.items_distinta_base[0].id_commessa,
          id_commessa_padre: this.articolo_sel.id_commessa,
          data_commessa:
            this.items_distinta_base[0].data_commessa != null &&
            this.items_distinta_base[0].data_commessa != ""
              ? this.items_distinta_base[0].data_commessa.substring(0, 10)
              : "",
          data_consegna:
            this.items_distinta_base[0].data_consegna != null &&
            this.items_distinta_base[0].data_consegna != ""
              ? this.items_distinta_base[0].data_consegna.substring(0, 10)
              : "",
          tabella: arr_tmp,
          flag_componente: 1,
        },
      };

      return this.$store
        .dispatch("api", setcommessamultipla)
        .then(async (res) => {
          this.overlay = false;

          if (res.status === 200) {
            // Stampo una snackbar di conferma
            this.$refs.SnackbarQV.print(
              "success",
              "Commessa salvata con successo."
            );
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità rilevata, non è stato possibile caricare i dati; codice errore: ${res.status}.`
            );
            return false;
          }
        })
        .catch((err) => {
          this.conferma_commessa_multipla = false;
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(err.response.data.message).result}.`
          );
          return false;
        });
    },
    setCommessaMultipla() {
      this.overlay = true;

      const a_tmp = Array.from(this.tabella_distinta_bk);
      a_tmp[0].id_responsabile =
        this.id_capobarca_sel === null || this.id_capobarca_sel === undefined
          ? null
          : this.id_capobarca_sel;

      a_tmp.forEach((elem) => {
        // Modifico il campo id_componente per comodità di BE.
        elem.id_componente = elem.id_padre == null ? 0 : elem.id_padre;

        // Genero il campo qtaTotale per comodità di BE.
        elem.qtaTotale = elem.quantita == null ? 1 : elem.quantita;

        /* Creo dei campi qtaTotale_originale e qtaTotale_somma che mi
         * torneranno utili in seguito per calcolare la quantità di
         * oggetti da produrre. */
        elem.qtaTotale_originale = elem.quantita == null ? 1 : elem.quantita;
        elem.qtaTotale_somma = 0;

        /* Inserisco il campo chkgenera che serve al
         * BE per generare la commessa di ogni elemento. */
        elem.chkgenera = 1;
      });

      /* Porto in stringa le quantità di ogni commessa, altrimenti
       * il BE quando applica Newtonsoft.JSONconvert.DeserializeObject
       * disuo arrotonderebbe male i numeri in virgola mobile. */
      a_tmp.forEach((e) => {
        e.quantita = e.quantita + "";
        e.qtaTotale = e.qtaTotale + "";
        e.qtaTotale_originale = e.qtaTotale_originale + "";
      });

      /* Eseguo la chiamata per avere le fasi di lavorazione
       * necessarie per tutti i componenti di questo articolo. */
      const setcommessamultipla = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessamultipla",
          token: localStorage.getItem("user_token"),
          cod_articolo: this.cod_articolo_sel,
          data_commessa: this.data_commessa,
          data_consegna: this.data_consegna,
          tabella: Array.from(a_tmp),
          flag_produzione: 1,
          flag_componente: 0,
        },
      };

      this.data_commessa = "";
      this.data_consegna = "";

      this.$store
        .dispatch("api", setcommessamultipla)
        .then((res) => {
          this.overlay = false;

          if (res.status === 200) {
            // Stampo una snackbar di conferma
            this.$refs.SnackbarQV.print(
              "success",
              "Commessa salvata con successo."
            );
            this.conferma_commessa_multipla = false;
            this.getCommessaMultipla();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità rilevata, non è stato possibile caricare i dati; codice errore: ${res.status}.`
            );
          }
        })
        .catch((err) => {
          this.conferma_commessa_multipla = false;
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    setIndiceRicorsivo(array, val = 0) {
      for (let i = val; i < array.length; i++) {
        array[i].indice = i + 1;
        if (array[i].children && array[i].children.length > 0) {
          this.setIndiceRicorsivo(array[i].children, 0);
        }
      }
    },
    setPersonaleCommessa() {
      this.overlay = true;

      // Per ogni fase...
      this.commessa.commessa_dettaglio.forEach((f) => {
        const arr_profili_tmp = [];

        // Mi metto da parte il suo personale attuale.
        f.personale_new.forEach((p) => {
          /* A seconda delle operazioni svolte, gli oggetti potrebbero
           * contenere un id_personale o un id_utente. Faccio in modo
           * di usare quello che mi è disponibile di volta in volta
           * per organizzare gli oggetti da salvare a DB.*/
          if (p.id_utente) {
            const obj_tmp = {
              id_articolo: f.id_articolo,
              id_commessa_dettaglio: f.id_commessa_dettaglio,
              id_personale: p.id_utente,
              idciclo_fasi_personale: -1,
              nominativo: p.nominativo,
              validita: 1,
            };

            arr_profili_tmp.push(obj_tmp);
          } else {
            const obj_tmp = {
              id_articolo: f.id_articolo,
              id_commessa_dettaglio: f.id_commessa_dettaglio,
              id_personale: p.id_personale,
              idciclo_fasi_personale: -1,
              nominativo: p.nominativo,
              validita: 1,
            };

            arr_profili_tmp.push(obj_tmp);
          }
        });

        /* Confronto il personale attuale con quello originale e se
         * trovo qualcosa che c'era in origine ma non ora, lo aggiungo
         * a ciò che devo salvare mettendo validità a 0 perché vuol
         * dire che l'ho cancellato. */
        this.ciclo_lista_clone.forEach((f_o) => {
          if (f_o.id_commessa_dettaglio == f.id_commessa_dettaglio) {
            f_o.commessa_dettaglio_personale.forEach((p_o) => {
              let occorrenze = 0;
              arr_profili_tmp.forEach((p_n) => {
                if (p_o.id_personale == p_n.id_personale) {
                  p_n.idciclo_fasi_personale = p_o.idciclo_fasi_personale;
                  occorrenze = occorrenze + 1;
                }
              });

              if (occorrenze == 0) {
                const obj_tmp = {
                  id_articolo: f.id_articolo,
                  id_commessa_dettaglio: f.id_commessa_dettaglio,
                  id_personale: p_o.id_personale,
                  idciclo_fasi_personale: p_o.idciclo_fasi_personale,
                  nominativo: p_o.nominativo,
                  validita: 0,
                };

                arr_profili_tmp.push(obj_tmp);
              }
            });
          }
        });

        f.commessa_dettaglio_personale = arr_profili_tmp;
        delete f.personale_new;
      });

      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessa",
          token: localStorage.getItem("user_token"),
          id_articolo: this.commessa.commessa[0].id_articolo,
          id_commessa: this.commessa.commessa[0].id_commessa,
          id_profilo: localStorage.id_profilo,
          tabella: [this.commessa],
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.$refs.SnackbarQV.print(
              "success",
              "Personale salvato con successo."
            );
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione con il server."
            );
          }
          this.dialog_personale_fasi = false;
          this.getCommessaMultipla();
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicaizone col server, non è stato possibile salvare i dati."
          );
        });
    },
    setStatoCommessa() {
      // Tologo il focus al textfield del capobarca
      document.getElementById("autocomplete_stato_commessa").blur();

      this.tabella_modifica = new Array();
      // this.popolaArrayEliminazione(this.items_distinta_base[0].id_commessa);

      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessestato",
          token: localStorage.getItem("user_token"),
          tabella: [this.items_distinta_base[0].id_commessa],
          id_tabella: this.id_stato_sel,
        },
      };

      // Resetto l'identificativo dello stato scelto
      this.id_stato_sel = null;

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.$refs.SnackbarQV.print(
              "success",
              "L'aggiornamento dello stato commessa ha avuto successo."
            );

            // Aggiorno i dati
            this.getCommessaMultipla();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore nella comunicazione col server, impossibile annullare la commessa."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore nella comunicazione col server, impossibile annullare la commessa."
          );
        });
    },
    snackbarOpen() {
      this.$refs.SnackbarQV.print(
        "orange",
        `Aggiungere ad ogni Allegato dell'attività una descrizione.`
      );
    },
  },
  created() {},
  mounted() {
    /* Questo mounted serve per il componente di primo livello.
     * Le istruzioni per i componenti di livello successivo sono
     * specificate nella gestione del watch sulla prop "visible". */
    this.getTabelle();

    // Prendo la lista dei capibarca per poterli associare alla commessa.
    this.getTeam();

    // Assegno il cod_profilo per identificare il ruolo
    this.cod_profilo = localStorage.cod_profilo;
    this.prefisso_utente = localStorage.prefisso_user;
  },
};
</script>
<style scoped>
</style>